<template>
  <div class="section-posts" :class="[{'planner': activeSection == 'calendar'}]">
   
    <!-- <component-loader :progress="90" v-if="showLoader" :unlimitedProgress="true" :activeClose="true" v-on:close="showLoader = false"></component-loader> -->
    <div v-if="showLoader">
      <component-loader :progress="percentLoader" :activeClose="true" v-on:close="showLoader = false"></component-loader>
    </div>
    <!-- <div class="pages-sidebar" :class="{'contract': !advancedTabs}" v-click-outside="contractTabs"></div> -->
    <div class="pages-sidebar" :class="{'contract': tabsIsMinimize}">
      <div class="table-title" @click="toggleExpandTabs">
          <p>{{$t(activeSection == 'tab' ? 'dash.posts.title' : 'dash.tab.scheduler')}}</p>
      </div>
      <div class="show-setting">
        <!-- <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="advancedTabs">navigate_before</i>
        <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="!advancedTabs">navigate_next</i> -->
        <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="!tabsIsMinimize">navigate_before</i>
        <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="tabsIsMinimize">navigate_next</i>
      </div>
      <div class="search-page">
        <vs-input
          v-model="pageFilter"
          :class="{'input': true}"
          color="#B20564"
          class="inputx"
          icon-after="true"  icon="search"
          :placeholder="$t('dash.settings.user.label.page_filter')"
        />
      </div>
      <div class="filter-selected">
        <span @click="filterSelected = !filterSelected">{{ $t(!filterSelected ? `dash.pages-sidebar.filter-selected${selectedPages.length > 1 ? '-multi' : ''}` : 'dash.pages-sidebar.filter-all') }}</span>
        <Tooltip :text="$t(!selectAllPages ? `dash.pages-sidebar.cta-select-all` : 'dash.pages-sidebar.cta-unselect-all')" position="top">
          <img v-if="!selectAllPages" @click="selectAllPages = !selectAllPages" alt="Select all pages" src="../../../assets/img/select_all_icon.svg">
          <img v-else @click="selectAllPages = !selectAllPages" alt="Unselect pages" src="../../../assets/img/unselect_icon.svg">
          &nbsp;
        </Tooltip>
      </div>
      <ul v-if="groups && posts">
        <li class="group" v-for="group in groups" :key="group.id" :class="[{'show': group.show, 'hide': !checkPagesInGroup(group) || checkGroupFilter(group)}]">
          <div class="group-wrapper">
            <img v-if="!group.show" alt="show group" class="show-group" src="../../../assets/img/icon-show-group.svg" @click="toggleShowGroup(group)"/>
            <img v-else alt="hide group" class="hide-group" src="../../../assets/img/icon-hide-group.svg" @click="toggleShowGroup(group)"/>
            <div class="group-content">
              <Tooltip :text="group.name" position="top">
                <div class="group-name messagedefilant"><div :data-text="group.name"><span>{{ group.name }}</span></div></div>
                &nbsp;
              </Tooltip>
            </div>
            <div class="checkbox">
              <input
                type="checkbox"
                :id="`groups-${group.id}`"
                name="groups[]"
                :value="group.id"
                v-model="selectedGroups"
                @change="checkGroup(group)"
              >
              <span class="checkmark" :class="[{deselect: checkAllPagesGroupSelected(group)}]">
                <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                <span class="material-icons">remove</span>
              </span>
            </div>
          </div>
          <ul>
            <div v-for="item in group.pages" :key="item">
              <li class="page" v-if="findPage(item)"
                  :class="[{ disabled: !checkLock(findPage(item).network) || (!isUserPremiumActive && posts[0].pages.id !== findPage(item).id && !isUserPartner), 'hide': !checkPageFilter(findPage(item)) || pageWithoutBot(findPage(item)) || !checkSelected(findPage(item)) }]">
                <div class="page-wrapper" :class="{disabled: !checkLock(findPage(item).network)}">
                  <div class="checkbox">
                    <input
                      type="checkbox"
                      :id="`pages-${findPage(item).id}`"
                      name="pages[]"
                      :value="findPage(item)"
                      v-model="selectedPages"
                      :data-qa="`posts-selector-list-page-${findPage(item).name}`"
                      :disabled="!checkLock(findPage(item).network) || (!isUserPremiumActive && posts[0].pages.id !== findPage(item).id && !isUserPartner)"
                    >
                    <span class="checkmark">                  
                      <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                    </span>
                  </div>
                  <div class="page-content">
                    <Tooltip :text="findPage(item).name" position="top">
                      <page-image-avatar :page="findPage(item)"/>
                      <div class="page-name messagedefilant"><div :data-text="findPage(item).name"><span>{{ findPage(item).name }}</span></div></div>
                      &nbsp;
                    </Tooltip>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </li>
        <li class="page" v-for="(item, index) in posts" :key="item.pages.id" 
                :class="[{ current: selectedTab == index, disabled: !checkLock(item.pages.network) || (!isUserPremiumActive && posts[0].pages.id !== item.pages.id && !isUserPartner), 'hide': !checkPageFilter(item.pages) || pageInGroup(item.pages) || pageWithoutBot(item.pages) || !checkSelected(item.pages) }]">
          <div class="page-wrapper" :class="{disabled: !checkLock(item.pages.network) || (!isUserPremiumActive && index != 0 && !isUserPartner)}" v-if="!pageInGroup(item.pages)">
            <div class="page-content">
              <Tooltip :text="item.pages.name" position="top">
                <page-image-avatar :page="item.pages"/>
                <div class="page-name messagedefilant"><div :data-text="item.pages.name"><span>{{ item.pages.name }}</span></div></div>
                &nbsp;
              </Tooltip>
            </div>
            <div class="checkbox">
              <input
                type="checkbox"
                :id="`pages-${item.pages.id}`"
                name="pages[]"
                :value="item.pages"
                v-model="selectedPages"
                :data-qa="`posts-selector-list-page-${item.pages.name}`"
                :disabled="!checkLock(item.pages.network) || (!isUserPremiumActive && posts[0].pages.id !== item.pages.id && !isUserPartner)"
              >
              <span class="checkmark">
                <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    
    <div class="filters-wrapper">
      <div class="filter" :class="{'active' : filter.includes('all')}">
        <input 
          type="checkbox" 
          name="content" 
          value="all" 
          v-model="filter" 
          @change="[filter = ['all'], arrayPostsFilter(false)]" 
          data-qa="posts-filter-all"
          :disabled="filter.includes('all')"
        >
        <div class="filter-content">
          <p>{{$t('dash.posts.status.all')}}</p>
        </div>
      </div>
      <div class="filter" :class="{ 'active' : filter.includes('draft')}">
        <input
          type="checkbox"
          name="content"
          value="draft"
          v-model="filter"
          @change="[filter = filter.filter( f => f != 'all'), arrayPostsFilter(false)]"
          data-qa="posts-filter-draft"
          :disabled="filter.length == 1 && filter.includes('draft')"
        >
        <div class="filter-content">
          <p>{{$t('dash.posts.status.draft')}}</p>
        </div>
      </div>
      <div class="filter" :class="{ 'active' : filter.includes('queue')}">
        <input
          type="checkbox"
          name="content"
          value="queue"
          v-model="filter"
          @change="[filter = filter.filter( f => f != 'all'), arrayPostsFilter(false)]"
          data-qa="posts-filter-queue"
          :disabled="filter.length == 1 && filter.includes('queue')"
        >
        <div class="filter-content">
          <p>{{$t('dash.posts.status.inqueue')}}</p>
        </div>
      </div>
      <div class="filter" :class="{ 'active' : filter.includes('scheduled')}">
        <input
          type="checkbox"
          name="content"
          value="scheduled"
          v-model="filter"
          @change="[filter = filter.filter( f => f != 'all'), arrayPostsFilter(false)]"
          data-qa="posts-filter-scheduled"
          :disabled="filter.length == 1 && filter.includes('scheduled')"
        >
        <div class="filter-content">
          <p>{{$t('dash.posts.status.scheduled')}}</p>
        </div>
      </div>
      <div class="filter" :class="{ 'active' : filter.includes('posted')}">
        <input
          type="checkbox"
          name="content"
          value="posted"
          v-model="filter"
          @change="[filter = filter.filter( f => f != 'all'), arrayPostsFilter(false)]"
          data-qa="posts-filter-posted"
          :disabled="filter.length == 1 && filter.includes('posted')"
        >
        <div class="filter-content">
          <p>{{$t('dash.posts.status.posted')}}</p>
        </div>
      </div>
      <div class="filter" :class="{ 'active' : filter.includes('failed')}">
        <input
          type="checkbox"
          name="content"
          value="failed"
          v-model="filter"
          @change="[filter = filter.filter( f => f != 'all'), arrayPostsFilter(false)]"
          data-qa="posts-filter-failed"
          :disabled="filter.length == 1 && filter.includes('failed')"
        >
        <div class="filter-content">
          <p>{{$t('dash.posts.status.failed')}}</p>
        </div>
      </div>
      <div class="filter" :class="{ 'active' : filter.includes('removed')}">
        <input
          type="checkbox"
          name="content"
          value="removed"
          v-model="filter"
          @change="[filter = filter.filter( f => f != 'all'), arrayPostsFilter(false)]"
          data-qa="posts-filter-removed"
          :disabled="filter.length == 1 && filter.includes('removed')"
        >
        <div class="filter-content">
          <p>{{$t('dash.posts.status.removed')}}</p>
        </div>
      </div>
      <div class="filter" :class="{ 'active' : filter.includes('direct')}" v-if="activeSection == 'calendar' && activeSynchronized">
        <input
          type="checkbox"
          name="content"
          value="direct"
          v-model="filter"
          @change="[filter = filter.filter( f => f != 'all'), arrayPostsFilter(false)]"
          data-qa="posts-filter-direct"
          :disabled="filter.length == 1 && filter.includes('direct')"
        >
        <div class="filter-content">
          <p>{{$t('dash.post.direct')}}</p>
        </div>
      </div>
    </div>

    <vs-row v-show="!showAdd">
      <vs-col vs-justify="center" vs-align="center" vs-w="12">

        <div class="actions-wrapper" v-if="['Admin', 'Editor', 'Writter'].includes(getUserRole)">
          <Tooltip v-if="disableAddPost" :text="$t('dash.bots.status_ko')" position="top" style="float: left">
            <vs-button
              class="add-btn btn-large btn-img"
              color="#303030"
              @click="displayOverlay(true)"
              vs-type="filled"
              data-qa="open-manual-post"
              :disabled="true"
            >
              <p>{{$t('dash.posts.add')}}</p>
            </vs-button>
            &nbsp;
          </Tooltip>
          <vs-button
            v-else
            class="add-btn btn-large btn-img"
            color="#303030"
            @click="displayOverlay(true)"
            vs-type="filled"
            data-qa="open-manual-post"
          >
            <p>{{$t('dash.posts.add')}}</p>
            <!-- <img src="../../../assets/img/Add-icon.svg" alt="search"> -->
          </vs-button>

          <div class="frequency-wrapper">
            <vs-button color="primary" type="filled" icon="refresh" @click="retrievePosts(selectedTab, linked[selectedTab].id, null, null, true)"></vs-button>
            <Tooltip :text="$t('dash.frequency.refresh')" position="top">
              <select v-model="refresh.frequency">
                <option v-for="(freq, key) in refresh.allowed"
                  :key="key"
                  :value="freq"
                  :style="freq ? '' : 'color: gray'"
                >{{ freq ? freq + ' sec' : $t('dash.posts.no_refresh') }}</option>
              </select>
              &nbsp;
            </Tooltip>
          </div>
          
          <div class="share-planner synchronized" v-if="activeSection == 'calendar'" @click="!activeSynchronized ? synchronizePosts() : null" :class="[{activeSynchronized}]">
            <span>{{ $t(loadSynchronisation ? `dash.planner.synchronized.inprogress` : `dash.planner.synchronized`) }}</span>
            <component-loader v-if="loadSynchronisation" :progress="90" :unlimitedProgress="true"></component-loader>
          </div> 

          <div class="share-planner" v-if="activeSection == 'calendar' && ['Admin', 'Editor'].includes(getUserRole)" @click="popupSharedPlanner = true">
            <span>{{ $t(`dash.planner.share_planner`) }}</span>
          </div>  

          <vs-popup class="overlay groups shared-planner" 
                    :title="$t('dash.pages.group-shared-planner.overlay.title')" 
                    :active.sync="popupSharedPlanner">
                    
            <div class="edit-users" @click="goToListUsers()">{{ $t('dash.pages.group-shared-planner.overlay.edit') }}</div>
            <component-pages-selector
              :groups="groups"
              :type="'shared_planner'"
              :pagesAdded="selectedPages"
              v-on:submit="createSharedPlanner"
              v-if="popupSharedPlanner"
            ></component-pages-selector>

          </vs-popup>

          <vs-popup class="overlay groups shared-planner-url" 
                    :title="$t('dash.pages.group-shared-planner.overlay.title')" 
                    :active.sync="popupUrlSharedPlanner"
                    v-if="popupUrlSharedPlanner">
                    
            <div class="link_to_copy" @click="copyUrlSharedPlanner()">
              <span>{{ urlSharedPlanner.substr(0, 50) }} ...</span>
              <img src="../../../assets/img/copy_icon.svg" alt="unlock">
            </div>

            <br/>

            <vs-button class="btnx" type="filled" 
              @click.prevent="copyUrlSharedPlanner()"
            >
              {{$t('dash.button.copy')}}
            </vs-button>

          </vs-popup>
          
          <div v-if="activeExportImportFeatures && ['Admin', 'Editor'].includes(getUserRole)" class="export-import">
            <vs-button @click="[popupExport=true, filterExport=filter=['all'], arrayPostsFilter(true)]" class="btn-img" size="small" >
                      <img src="../../../assets/img/ico-export.svg" alt="unlock">
                      <p>Export</p>
            </vs-button>
            <vs-button @click="[popupImport=true, fileInput=fileInputParesed=[]]"  class="btn-img" size="small" >
                <img src="../../../assets/img/ico-import.svg" alt="unlock">
                <p>Import</p>
            </vs-button>
          </div>

        </div>
        <div class="actions-wrapper right" v-else>
            <div class="frequency-wrapper">
              <vs-button color="primary" type="filled" icon="refresh" @click="retrievePosts(selectedTab, linked[selectedTab].id)"></vs-button>
              <Tooltip :text="$t('dash.frequency.refresh')" position="top">
                <select v-model="refresh.frequency">
                  <option v-for="(freq, key) in refresh.allowed"
                    :key="key"
                    :value="freq"
                    :style="freq ? '' : 'color: gray'"
                  >{{ freq ? freq + ' sec' : $t('dash.posts.no_refresh') }}</option>
                </select>
                &nbsp;
              </Tooltip>
            </div>
          </div>
          
        <div class="page-selected" v-if="selectedPages.length == 1">
          <page-image-avatar :page="selectedPages[0]"/>
          <p class="page-name">{{ selectedPages[0].name }}</p>
        </div>
        <div class="page-selected" v-else>
          <Tooltip
            v-for="(pageItem, pageIndex) in selectedPages"
            :key="pageIndex"
            :text="pageItem.name"
            position="top"
          >
            <div @click="unselectPage(pageItem)">
              <page-image-avatar :page="pageItem"/>
            </div>
            &nbsp;
          </Tooltip>
        </div>
        <div class="tables-wrapper">
          <div class="type-calendar" v-if="activeSection == 'calendar'" @click="toggleTypeCalendar">
            <Tooltip :text="$t('dash.button.calendar_view_week')" position="top" v-if="monthly">
              <i class="vs-icon notranslate icon-scale material-icons null" >view_week</i>
         
            </Tooltip>
            <Tooltip :text="$t('dash.button.calendar_view_month')" position="top" v-else>
              <i class="vs-icon notranslate icon-scale material-icons null">today</i>
      
            </Tooltip>
          </div>
          
          <div class="tabs-content">
            <div class="tab-content">
              <component-customtables
                :key="'posts-table-'+filter+'-page-'"
                :gridData="{posts: listPosts, pages: selectedPages[0]}"
                :page="selectedTab"
                :pages="selectedPages"
                :columns="columns"
                :filter="filter"
                :canUseCustomSources="checkLock('source_choice')"
                v-on:edit="editPost"
                v-on:post="editPost"
                v-on:validate="add"
                v-on:deleteScheduled="deleteScheduled"
                v-on:excludeNews="excludeNews"
                v-on:resharePost="resharePost"
                v-on:retweetPost="retweetPost"
                v-on:editDraft="editDraft"
                v-on:openLoader="openLoader"
                v-on:shareStory="shareToStory"
                v-on:removeDrafts="removeDrafts"
                v-on:duplicatePost="duplicatePost"
                :name="'posts'"
                v-if="activeSection == 'tab' && listPosts && selectedPages.length"
              ></component-customtables>
              <component-posts-calendar
                :key="'calendar-table-'+filter+'-page-'"
                :gridData="{posts: listPosts, calendar: weeklyPlanner, monthlyCalendar: monthlyPlanner, pages: selectedPages[0]}"
                :page="selectedTab"
                :pages="selectedPages"
                :columns="columns"
                :filter="filter"
                :canUseCustomSources="checkLock('source_choice')"
                :isDeleteSlot ="isDeleteSlot"
                :slotDate="slotDate"
                :slotBot="slotBot"
                :startDate="startDate"
                :openPostSidebar="openPostSidebar"
                v-on:edit="editPost"
                v-on:post="editPost"
                v-on:show="showPost"
                v-on:add="addPost"
                v-on:validate="add"
                v-on:reload="reloadDataCalendar"
                v-on:excludeNews="excludeNews"
                v-on:deleteScheduled="deleteScheduled"
                v-on:resetDeleteSot="resetDeleteSot"
                v-on:processInsights="processInsights"
                v-on:changeStartDate="changeStartDate"
                v-on:resharePost="resharePost"
                v-on:retweetPost="retweetPost"
                v-on:editDraft="editDraft"
                v-on:openLoader="openLoader"
                v-on:shareStory="shareToStory"
                v-on:removeDrafts="removeDrafts"
                v-on:duplicatePost="duplicatePost"
                v-on:validateDraft="validateDraft"
                :name="'posts-calendar'"
                v-if="activeSection == 'calendar' && activePlanner && selectedPages.length"
              ></component-posts-calendar>
            </div>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <div v-show="showAdd">  
     
      <component-posts-overlay ref="postOvrelay" class="posts-form content"
        v-if="groups && !closePostsOverlay"
        v-on:add="add"
        v-on:addWithoutBot="addWithoutBot"
        v-on:update="update"
        v-on:close="close"
        v-on:deleteScheduled="deleteScheduled"
        v-on:updateDrafts="filterPosts"
        v-on:updatePages="filterPosts"
        v-on:removeDrafts="removeDrafts"
        v-on:setStoryShare="setStoryShare"
        v-on:getPagesEvent="getListPages"
        :linked="linked"
        :content="popup.content"
        :bots="bots"
        :validated="popup.validated"
        :state="overlayState"
        :post="overlayItem"
        :page="overlayPage"
        :pages="overlayPages"
        :scheduledOverlay="scheduledOverlay"
        :showAdd="showAdd"
        :activeOptimalTimes="activeOptimalTimes"
        :recap="recap"
        :groupsCopy="groups"
        :storyShare="shareStory"
        :tabsIsMinimize="tabsIsMinimize"
        v-on:minimizeTabsEvent="minimizeTabsEvent"
      ></component-posts-overlay>
    </div>

    <component-posts-recap ref="postsRecap"
      v-if="recap.length"
      v-show="!showAdd"
      class="recap"
      :linked="linked"
      :bots="bots"
      :recap="recap"
      :show="showRecap"
      :totalPost="totalPost"
      :countPost="countCurrentMultiplePosts"
      v-on:minimize="minimizeRecap"
      v-on:maximize="maximizeRecap"
      v-on:close="removeRecap"
      v-on:edit="editPost"
      :key="`postsRecap-${keyRecap}`"
    ></component-posts-recap>

    <vs-popup class="exportPopup" :title="`${$t('dash.posts.export_popuptitle')} (Beta)`" :active.sync="popupExport">

      <p style="margin-bottom:20px">{{$t('dash.posts.export_description')}}</p>

        <div class="export-date">
          <component-datepicker
            class="date"
            :from="this.disabledDate.from"
            :to="this.disabledDate.to"
            v-on:picked="setDateStart"
            :date="dateStart"
          ></component-datepicker>
          <component-datepicker
            class="date"
            :from="this.disabledDate.from"
            :to="this.disabledDate.to"
            v-on:picked="setDateEnd"
            :date="dateEnd"
          ></component-datepicker>
        </div>

        <div class="actions-wrapper export">
          <div class="filters-wrapper export">
            <div class="filterExport" :class="{ 'active' : filterExport.includes('all')}">
              <input 
                type="checkbox" 
                name="content2" 
                value="all" 
                v-model="filterExport" 
                @change="[filterExport = ['all'], arrayPostsFilter(true)]"
                :disabled="filterExport.includes('all')"
              >
              <div class="filter-content">
                <p>{{$t('dash.posts.status.all')}}</p>
              </div>
            </div>
            <div class="filterExport" :class="{ 'active' : filterExport.includes('queue')}">
              <input
                type="checkbox"
                name="content2"
                value="queue"
                v-model="filterExport"
                @change="[filterExport = filterExport.filter( f => f != 'all'), arrayPostsFilter(true)]"
                :disabled="filter.length == 1 && filter.includes('queue')"
              >
              <div class="filter-content">
                <p>{{$t('dash.posts.status.inqueue')}}</p>
                <img class="icon-grey" src="../../../assets/img/icon_wait_grey.svg" alt="queue">
                <img class="icon-white" src="../../../assets/img/icon_wait_white.svg" alt="queue">
              </div>
            </div>
            <div class="filterExport" :class="{ 'active' : filterExport.includes('scheduled')}">
              <input
                type="checkbox"
                name="content2"
                value="scheduled"
                v-model="filterExport"
                @change="[filterExport = filterExport.filter( f => f != 'all'), arrayPostsFilter(true)]"
                :disabled="filter.length == 1 && filter.includes('scheduled')"
              >
              <div class="filter-content">
                <p>{{$t('dash.posts.status.scheduled')}}</p>
                <img class="icon-grey" src="../../../assets/img/icon_time_grey.svg" alt="scheduled">
                <img
                  class="icon-white"
                  src="../../../assets/img/icon_time_white.svg"
                  alt="scheduled"
                >
              </div>
            </div>
            <div class="filterExport" :class="{ 'active' : filterExport.includes('posted')}">
              <input
                type="checkbox"
                name="content2"
                value="posted"
                v-model="filterExport"
                @change="[filterExport = filterExport.filter( f => f != 'all'), arrayPostsFilter(true)]"
                :disabled="filter.length == 1 && filter.includes('posted')"
              >
              <div class="filter-content">
                <p>{{$t('dash.posts.status.posted')}}</p>
                <img class="icon-grey" src="../../../assets/img/icon_check_grey.svg" alt="posted">
                <img class="icon-white" src="../../../assets/img/icon_check_white.svg" alt="posted">
              </div>
            </div>
            <div class="filterExport" :class="{ 'active' : filterExport.includes('failed')}">
              <input
                type="checkbox"
                name="content2"
                value="failed"
                v-model="filterExport"
                @change="[filterExport = filterExport.filter( f => f != 'all'), arrayPostsFilter(true)]"
                :disabled="filter.length == 1 && filter.includes('failed')"
              >
              <div class="filter-content">
                <p>{{$t('dash.posts.status.failed')}}</p>
                <img class="icon-grey" src="../../../assets/img/icon_check_grey.svg" alt="failed">
                <img class="icon-white" src="../../../assets/img/icon_check_white.svg" alt="failed">
              </div>
            </div>
          </div>
        </div>

        <vs-button class="exportBtn"
          @click="exportData()"
          v-if='postsToExport.length > 0'
          vs-type="filled" >
          <p>Export ({{this.postsToExport.length}})</p>
        </vs-button>
        <vs-button class="exportBtn"
          disabled v-else >
          <p>Export (0)</p>
        </vs-button> 

    </vs-popup>

    <vs-popup class="importPopup" :title="`${$t('dash.posts.import_popuptitle')} (Beta)`" :active.sync="popupImport">
        
        <div class="importcsv-popup">
          <div  id="box"  @drop="[drop($event), loadCSV($event)]">
            <img style="height:80px; width:80px; opacity:0.2; margin:10px" src="../../../assets/img/csv.svg" alt="search">
            <input type="file" id="file" 
            @change="[onChange(), loadCSV($event)]" ref="file" accept=".csv"  />
            <label id="labelImport">
                {{$t('dash.posts.import_dragdrop')}}
            </label>
            <ul style="margin:5px" v-if="this.fileInput.length && isCSV(this.fileInput)" v-cloak>
                {{ fileInput[0].name }}
                <vs-button style="margin:5px; opacity:0.7;" size="small" @click="remove(fileInput)" :title="$t('dash.posts.import_remove')">
                  x</vs-button>
            </ul>
           

          </div>

          <div id="updateBtn">
            <vs-button v-if="fileInputParesed.length != 0" @click="multipleSchedules()">Update</vs-button>
            <vs-button disabled v-else>Update</vs-button>
          </div>
        </div>
        

    </vs-popup>
  </div>
</template>

<script>
import store from './../../../store/index.js';
import componentCustomtables from './../CustomTables.vue'
import componentPostsOverlay from './../overlay/Posts.vue'
import componentPostsRecap from './../overlay/Recap.vue'
import Posts from '../../mixins/Posts'
import User from '../../mixins/User'
import Insights from '../../mixins/Insights'
import Pages from '../../mixins/Pages'
import Bots from '../../mixins/Bots'
import Common from '../../mixins/Common'
import Groups from '../../mixins/Groups'
import Drafts from '../../mixins/Drafts'
import Notif from '../../mixins/Notif'
import Settings from '../../mixins/Settings'
import componentPostsCalendar from './../PostsCalendar.vue'
import componentDatepicker from './../Datepicker.vue'
import PageImageAvatar from './../PageImageAvatar.vue'
import componentLoader from './../overlay/Loader.vue'
import ClickOutside from 'vue-click-outside'
import componentPagesSelector from './../overlay/PagesSelector.vue'

import Queuer from '../../../utils/Queuer'
import moment from 'moment'
import Tooltip from './../tooltip/tooltipInit.vue'

const NB_POSTS_TO_GET = 100

export default {
  name: 'component-posts',

  components: {
    componentCustomtables,
    componentPostsOverlay,
    componentPostsRecap,
    componentPostsCalendar,
    componentDatepicker, 
    PageImageAvatar,
    componentLoader,
    componentPagesSelector,
    Tooltip
  },

  mixins: [Common, Insights, User, Bots, Pages, Posts, Groups, Drafts, Notif, Settings],

  directives: {
    ClickOutside
  },

  data() {
    return {
  
      shareStory: null,
      popInterval: null,
      refresh: {
        last: moment(),
        enabled: true,
        frequency: 240,
        intervalObj: null,
        allowed: [
          0,
          30, // seconds
          60,
          120,
          240,
          300,
        ],
      },
      filter: ['all'],
      filterExport: ['all'],
      selectedTab: 0,
      showAdd: false,
      activeOptimalTimes: false,
      overlayState: 'new',
      overlayItem: null,
      overlayPage: null,
      overlayPages: null,
      popup: {
        validated: false,
        title: 'Post',
        content: ''
      },
      linked: [],
      source: {
        page: ''
      },
      sources: [],
      columns: ['status', 'published_at', 'title', 'source', 'both'],
      posts: [],
      postsTmp: [],
      listPosts: null,
      weeklyPlanner: null,
      monthlyPlanner: null,
      nbPostsToGet: NB_POSTS_TO_GET,
      mode: 'tab',
      scheduledOverlay: {
        day: null,
        hour: null,
        minute: null
      },
      indexPage: 0,
      nextComponent: false,

      waitGetCalendar: true,

      isDeleteSlot: false,
      slotDate: null,
      slotBot: null,
      pageFilter: '',
      startDate: moment().hour(0).minute(0).second(0),
      popupImport: false,
      popupExport: false,
      parse_header: [],
      parse_csv: [],
      sortOrders:{},
      
      postsToExport : [],
      fileInput: [], // Store our uploaded file
      fileInputParesed : [],
      dateStart: moment().subtract(3, 'day').startOf('day').toDate(), 
      dateEnd: moment().toDate(),

      queueMeta: null,

      recap: [],
      keyRecap: 0,
      showRecap: false,
      hidePostOverlay: false,
      closePostsOverlay: true,
      
      selectedPages: [],
      // selectedPages: localStorage.last_selected_pages 
      //                 && !['undefined', '[]', '[null]'].includes(localStorage.last_selected_pages) 
      //                 && JSON.parse(localStorage.last_selected_pages) 
      //                     ? JSON.parse(localStorage.last_selected_pages) 
      //                     : (localStorage.pages && !['undefined', '[]', '[null]'].includes(localStorage.pages) && JSON.parse(localStorage.pages)
      //                           ? (localStorage.user && JSON.parse(localStorage.user) && JSON.parse(localStorage.user).role && JSON.parse(localStorage.user).role.length && JSON.parse(localStorage.user).role[0] == 'Viewer'
      //                                 ? JSON.parse(localStorage.pages)
      //                                 : [JSON.parse(localStorage.pages)[0]])
      //                           : []),
      selectedGroups: [],
      firstSelectGroup: true,
      groups: null,
      showLoader: false,
      percentLoader: 0,
      eventSource: null,
      // advancedTabs: true,

      drafts: [],

      bots: [],

      currentPosted: [],
      countCurrentMultiplePosts: 0,
      totalPost: 0,

      popupSharedPlanner: false,
      popupUrlSharedPlanner: false,
      urlSharedPlanner: null,

      monthly: false,
      filterSelected: false,
      selectAllPages: false,

      openPostSidebar: null,

      activeSynchronized: false,
      loadSynchronisation: false
    }
  },

  props: {
    addPostHeader: Boolean,
    tabsIsMinimize: Boolean
  },

  beforeMount(){
    this.$ga.page(this.$router)
  },

  mounted() {
    localStorage.setItem('section', this.activeSection == 'calendar' ? 'planner' : 'posts')

    if(this.activeSection == 'calendar' && localStorage.typeCalendar == "monthly")
      this.monthly = true

    new Promise(async (resolve, reject) => {
      // await this.fetchGroups()
      this.fetchGroups()
      resolve()
    })
    .then(this.getListPages)
    .then(() => {
      // Get bots
      this.getBots()
    })
    .then(() => {
      // Create array of pages to be filled
      this.createArray()
    })
    .then(() => {

      let params = this.$route.params

      const usp = new URLSearchParams(location.href.substring(location.href.indexOf('?post_id=')+1))
      if (['post_id', 'page_id'].every(p => usp.has(p))) {
        const post_id = usp.get('post_id')
        const page_id = usp.get('page_id')
        const bot_id = usp.get('bot_id')
        params = {
          pageId: page_id,
          botId: bot_id,
          newsId: post_id
        }
        if(usp.has('edit_post'))
          params.editPost = post_id
        else if(usp.has('show_post'))
          params.showPost = post_id
        else if(usp.has('validate_post'))
          params.validatePost = post_id
        else if(usp.has('schedule_post'))
          params.schedulePost = post_id
        if(usp.has('is_draft') && usp.get('is_draft') == 'true')
          params.isDraft = true
        if(usp.has('is_error'))
          params.isError = true 
        if(usp.has('no_redirection'))
          params.no_redirection = true
      }

      // Fill form
      if (this.$route.params.post) {
        // From global search
        this.overlayState = 'search'
        this.overlayItem = this.$route.params.post
        this.overlayItem.pages = 0
        this.fillPost()
      } else if (this.$route.params.page) {
        // From overview
        this.overlayState = 'pagenew'
        this.overlayPage = this.$route.params.page
        this.overlayPages = [this.$route.params.page]
        this.displayOverlay()
      } else if (this.$route.params.newPost) {
        // From header
        this.overlayState = 'new'
        this.displayOverlay(true)
      } else if (params.pageId) {
        // From deep link show post
        this.selectedPages = this.posts.filter(p => p.pages.id == params.pageId)
                                    .map(p => p.pages);
                                    
        (params.isDraft ? this.findDraft(params.botId, params.newsId)
                                    : this.getPost(params.botId, params.newsId))
        .then(res => {
          if(res && res.body && res.body.post){
            console.log('find post', res.body.post)
            let post = res.body.post

            if (params.editPost || (params.isError && params.validatePost)) {
    
              if(params.isDraft) {
                this.editDraft(post.draft)
              }
              else {
                post = {
                  ...post,
                  status: params.isError ? 'failed' : 'scheduled',
                  _bots: [this.bots.find(b => [b.id, b.uid].includes(params.botId))],
                  toPost: params.isError && params.validatePost
                };

                this.close()
                this.closePostsOverlay = false
                this.editPost.id = post.id
                this.overlayState = params.isError ? 'duplicate-post' : 'edit'
                this.overlayItem = post
                this.overlayPage = params.pageId
                let clean = false
                let day = moment(post.page[0].scheduled_date).local().hours(0).minutes(0).seconds(0)
                let hour = moment(post.page[0].scheduled_date).local().hours()
                let minute = moment(post.page[0].scheduled_date).local().minutes()
                
                if(post.page[0].draft)
                  this.overlayPages = JSON.parse(post.page[0].draft).bot.filter(bId => this.bots.find(b => b.id == bId)).map(bId => this.bots.find(b => b.id == bId).page.id)
  
                this.displayOverlay(clean, day, hour, minute)
              }

            } else if (params.showPost
                          || params.validatePost
                          || params.schedulePost) {

              const user = this.user ? this.user
                            : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)

              let isAffectedUser = (post.page && post.page[0] && post.page[0].affectedTo && post.page[0].affectedTo.user && post.page[0].affectedTo.user.id == user.id)
                              || (post.page && post.page[0] && post.page[0].affectedTo && post.page[0].affectedTo.users && post.page[0].affectedTo.users.find(u => u.id == user.id))


              let status = null
              if(post.page && post.page[0]) {
                if(post.page[0].status == 2) status = 'posted'
                else if(post.page[0].status == 1) status = 'scheduled'
                else if([4,5].includes(post.page[0].status)) status = 'failed'
              }

              this.openPostSidebar = {
                ...post,
                status: params.isDraft ? 'draft' : (params.isError ? 'failed' : (status || 'scheduled')),
                _bots: [this.bots.find(b => [b.id, b.uid].includes(params.botId))],
                validatePost: isAffectedUser ? params.validatePost : null,
                schedulePost: isAffectedUser ? params.schedulePost : null
              }
            } 
          }        
          localStorage.removeItem('redirect_params_url_action')
        })
       
      } else if (localStorage.preview_overlay) {
       
        let page = JSON.parse(localStorage.preview_overlay);

        this.selectedPages = this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.$store.getters['selectPage/selectPageAllPages'][id]);
        console.log(this.overlayPage, "overlayepage");
        
        let draft = JSON.parse(localStorage.draft);
        console.log("localStorage.draft",draft, typeof draft);
        
        if(draft.saveAllFormData){

          this.$store.commit('postCreator/setDataForDuplicatePost', {
            draft: draft,
            pages: [page.id]
          });
          this.$router.push('/dash/postCreator/duplicate');

        }
        else
          this.editDraft({data: draft}, page)
      }

      this.popInterval = setInterval(() => {
        if(!this.overlayItem && this.$route.params.post){
          this.overlayState = 'search'
          this.overlayItem = this.$route.params.post
          this.overlayItem.pages = 0
          this.fillPost()
          this.$route.params.post = null
        }
      }, 500)
    })
  },

  beforeDestroy() {
    if (!this.refresh.intervalObj) {
      return
    }
    clearInterval(this.refresh.intervalObj)

    if(this.eventSource) 
      this.eventSource.close()


    console.log("beforeDestroy page",this.selectedPages.length)

    const pagesSelected = this.selectedPages.reduce((acc, {id: pageId})=> {
      if (this.allPages[pageId]) acc.push(this.allPages[pageId])
      return acc
    },[])

    console.log("beforeDestroy page",pagesSelected)
    this.$store.commit('selectPage/updatePagesSelected', {pagesId: pagesSelected.map(p => p.id)});
  },

  computed: {
    allPages() {
      return this.$store.getters['selectPage/selectPageAllPages'];
    },

    getUserRole() {
      const user = this.user ? this.user
                             : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)
      if(!user) return null
      if(user.admin)
        return 'Admin'
      else
        return user.role && user.role.length
                    ? user.role[0]
                    : 'Editor'
      
    },

    disableAddPost(){
      if(this.selectedPages.length){
        let bots = this.bots.filter(b => this.selectedPages.map(p => p.id).includes(b.page.id))
        // return bots.length && bots.find(b => b.status == 0)
        //         && !(this.selectedPages.find(p => p.story_config && p.story_config.created))
        //         ? true : false
        return bots.length && bots.every(b => b.status == 0)
                && !(this.selectedPages.every(p => p.story_config && p.story_config.created))
                ? true : false
      }
    
      return false
    },

    formattedLastRefresh() {
      return this.refresh.last.format(
        this.$t('dash.moment_format.time_with_seconds')
      )
    },

    activeSection() {
      return this.$route.path.endsWith('planner')
          ? 'calendar'
          : 'tab'
    },

    activeExportImportFeatures(){
      const user = this.user ? this.user
                             : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)
      const force = localStorage.forceExportImportFeatures ? JSON.parse(localStorage.forceExportImportFeatures) : false
      return user && (user.email.includes("@mashup-web.com") || user.email.includes("vdiakov@reworldmedia.com") || force == true)
    },

    activePlanner() {
      
      const accounts = [
        'aed13e10-be3d-4d3b-840f-a1f4765383ac', //newcom-regie
      ]

      const user = this.user ? this.user
                             : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)
      const force = localStorage.forcePlanner ? JSON.parse(localStorage.forcePlanner) : false
      return user && (accounts.includes(user.account) || this.checkLock('planner') || user.email.includes("@mashup-web.com")  || force == true)
    },

    activeLog(){
      return true
      // const logUser = [
      //   //sandbox
      //   'aiminne+free1@mashup-web.com',
      //   //prod
      //   "aiminne@mashup-web.com",
      //   "matthieu@mashup-web.com",
      //   "vdiakov@reworldmedia.com",
      //   "ldesmarecaux@reworldmedia.com",
      //   'ajeunet@reworldmedia.com',
      //   'mashup.md@reworldmedia.com',
      //   "a.samari@sfmd.fr",
      //   "egrasset@reworldmedia.com",
      //   'pascale@dreamago.com'
      // ]
      // const logAccount = [
      //   //prod
      //   "c93f4d0a-d1eb-4561-8071-bd4ef9fdf72a", //rcf
      //   "ed24f2ca-61dc-477a-9508-237845ff9423", //studiomandarine
      //   "da502f9e-c999-4896-baed-4e1c4110409a", //wmki
      //   "d2e5ed17-eaf3-4ba0-a2ba-9e1f95757776", //fcr
      // ]
      // const user = this.user ? this.user
      //                        : (localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null)
      // return logUser.includes(user.email) || logAccount.includes(user.account)
    },

    
    disabledDate() {
        if(this.posts[this.indexPage]) {
          let postsDate = this.posts[this.indexPage].posts.map(p => {
            switch(p.status){
              case 0:
                return moment(p.published_at)
              case 1:
                return moment(p.page[0].scheduled_date)
              case 2:
                return moment(p.page[0].posted_date)
              default:
                return moment()
            }
          })
          let min = moment.min(postsDate)
          let max = moment.max(postsDate)

          return {
            from: moment(min).toDate(),
            to : moment(max).toDate()
          }
        }
        
        return {
          from: moment().toDate(),
          to : moment().toDate()
        }

    },
  },

  methods: {

    validateDraft(draft) {
      this.editDraft({
        ...draft,
        toSchedule: true
      })
    },

    toggleTypeCalendar() {
      this.monthly = !this.monthly
      localStorage.typeCalendar = this.monthly ? "monthly" : "weekly"
      this.retrievePosts(this.selectedTab, this.linked[this.selectedTab].id)
    },

    setStoryShare(value) {
      this.shareStory = value;
    },
    
    toggleExpandTabs() {
      // this.advancedTabs = !this.advancedTabs      
      this.$emit('minimizeTabs', !this.tabsIsMinimize)
    },

    contractTabs(){
      // this.advancedTabs = false
      if(!this.showAdd)
        this.$emit('minimizeTabs', true)
    },

    minimizeTabsEvent(val) {
      console.log('minimizeTabs post', val)
      this.$emit('minimizeTabs', val)
    },

    log() {
      console.log(...arguments)
    },

    /** check page filter **/
    checkPageFilter(page){
      return page.name.toLowerCase().includes(this.pageFilter.toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.toLowerCase()) || (this.pageInGroup(page) && this.pageInGroup(page).name.toLowerCase().includes(this.pageFilter.toLowerCase()))
    },

    checkSelected(page) {
      if(!this.filterSelected)
        return true
      else 
        return this.selectedPages.find(p => p.id == page.id)
    },

    async fetchGroups() {
      let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
      if(localStorage.groups && localStorage.groups != '[]') this.groups = JSON.parse(localStorage.groups)
      else this.groups = []
  
      // if(localStorage.pages && JSON.parse(localStorage.pages) && JSON.parse(localStorage.pages).length > 1)
        await this.getGroups().then(res => {
          this.groups = res.map(group => {
            // return {...group, show: true}
            return {...group, show: !hideGroups.find(g => g == group.id)}
          })

          // this.groups = this.groups.map(g => {
          //   return {
          //     ...g,
          //     pages: g.pages.filter(page => this.posts.find(p => p.pages.id == page))
          //   }
          // })
          // this.updateGroups()
        })
        localStorage.groups = JSON.stringify(this.groups)

        this.groups = this.groups.map(g => {
          return {
            ...g,
            pages: g.pages.filter(page => this.posts.find(p => p.pages.id == page))
          }
        })
        this.updateGroups()

      // else this.groups = []
    },

    toggleShowGroup(group) {
      let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
      if(group.show)
        hideGroups.push(group.id)
      else 
        hideGroups = hideGroups.filter(g => g != group.id)
      localStorage.setItem('hideGroups', JSON.stringify(hideGroups))
      
      let index = this.groups.findIndex(g => g.id == group.id)
      this.$set(this.groups[index], 'show', !group.show)
    },

    findPage(pageId) {
      let posts = this.posts.find(p => p.pages.id == pageId)
      return posts && posts.pages ? posts.pages : null
    },

    pageInGroup(page) {
      return this.groups.find(g => g.pages.includes(page.id))
    },

    pageWithoutBot(page) {
      return !this.bots.find(b => b.page.id == page.id)
    },

    checkGroupFilter(group){
      if(!group) return false
      return group.pages.every(p => !this.findPage(p) || (this.findPage(p) && (!this.checkPageFilter(this.findPage(p)) || !this.checkSelected(this.findPage(p)))))
    },

    checkPagesInGroup(group) {
      return group.pages.some(p => this.findPage(p) && !this.pageWithoutBot(this.findPage(p)))
    },

    checkAllPagesGroupSelected(group){
      let countPages = this.selectedPages.filter(p => group.pages.includes(p.id)).length
      return 0 < countPages && countPages < group.pages.length
    },

    checkGroup(group){
      if(this.selectedGroups.includes(group.id)){
        console.log('add page from', group.id)
        
        let checkPage = (p) => this.checkLock(p.network) // && p.bot_status 
        this.selectedPages = this.firstSelectGroup 
                                // ? this.posts.filter(b => group.pages.includes(b.pages.id) && checkPage(b.pages) && !this.pageWithoutBot(this.findPage(b.pages.id))).map(p => p.pages)
                                // : [...new Set(this.selectedPages.concat(this.posts.filter(item => group.pages.includes(item.pages.id) && checkPage(item.pages) && !this.pageWithoutBot(this.findPage(item.pages.id))).map(p => p.pages)))]
                                ? this.posts.filter(b => group.pages.includes(b.pages.id) && checkPage(b.pages) && this.checkPageFilter(b.pages) && !this.pageWithoutBot(this.findPage(b.pages.id))).map(p => p.pages)
                                : [...new Set(this.selectedPages.concat(this.posts.filter(item => group.pages.includes(item.pages.id) && checkPage(item.pages) && this.checkPageFilter(item.pages) && !this.pageWithoutBot(this.findPage(item.pages.id))).map(p => p.pages)))]
        this.firstSelectGroup = false
        // this.selectedPages = [...new Set(this.selectedPages.concat(this.posts.filter(item => group.pages.includes(item.pages.id) && checkPage(item.pages) && !this.pageWithoutBot(this.findPage(item.pages.id))).map(p => p.pages)))]
        this.selectedPages = [...new Set(this.selectedPages.concat(this.posts.filter(item => group.pages.includes(item.pages.id) && checkPage(item.pages) && this.checkPageFilter(item.pages) && !this.pageWithoutBot(this.findPage(item.pages.id))).map(p => p.pages)))]

        for(let b of this.selectedPages){
          let botsPage = this.posts.filter(p => p.pages.id == b.id)
          if(botsPage.length > 1) 
            this.selectedPages = this.selectedPages.filter(p => !botsPage.slice(1).map(bPage => bPage.id).includes(p.id))
        }
      }
      else {
        console.log('remove page from', group.id)
        this.selectedPages = this.selectedPages.filter(p => !group.pages.includes(p.id))
      }
    },

    unselectPage(page){
      this.selectedPages = this.selectedPages.filter(p => p.id != page.id)
      const elements = document.getElementsByClassName("vs-tooltip");
      while (elements.length > 0) elements[0].remove();
      localStorage.setItem('last_selected_page', JSON.stringify(this.selectedPages[0]))
      localStorage.setItem('last_selected_pages', JSON.stringify(this.selectedPages))
    },

    /**²
     * Retrieve filter
     * @param {Object} obj - radio object
     */
    updateSelected: function(tab) {
      this.selectedTab = tab

      this.filter = ['all']

      if(this.posts[this.selectedTab])
        this.$set(this.posts[this.selectedTab], 'posts', [])
      if(this.activeSection == 'calendar') this.$set(this.posts[this.selectedTab], 'calendar', null)
      this.postsTmp = []

      // console.log('updateSelected reload')
      // if(this.activeSection == 'calendar') this.reloadDataCalendar()
      // this.contractTabs()

      localStorage.setItem('last_selected_page', JSON.stringify(this.selectedPages[0]))
      localStorage.setItem('last_selected_pages', JSON.stringify(this.selectedPages))
    },

    postPost() {},

    fillPost() {
      this.editPost.id = this.overlayItem._id
      this.displayOverlay()
    },

    addPost(clean=false, day=null, hour=null, minute=null, deleteSlot=false, slotDate=null, slotBot=null) {
      if(!['Admin', 'Editor', 'Writter'].includes(this.getUserRole)) return

      if(deleteSlot){
        this.isDeleteSlot = true
        this.slotDate = slotDate
        this.slotBot = slotBot
      }
      this.displayOverlay(clean, day, hour, minute)
    },

    editPost(pages, id, status, deleteSlot=false, slotDate=null, slotBot=null) {
      if(!['Admin', 'Editor', 'Writter'].includes(this.getUserRole)) return

      this.close()
      this.closePostsOverlay = false
    

      if(deleteSlot){
        this.isDeleteSlot = true
        this.slotDate = slotDate
        this.slotBot = slotBot
      }

      console.log('edit post', status)
      console.log(pages, id)
      if (status === 'inqueue') {
        let post = this.listPosts.find(function(element) {
          return element._id === id
        })
        if (this.listPosts.filter(element => element._id === id).length > 1 && post.page && post.page[0] && post.page[0].network === 'facebook' && post.page[0].storification) {
          post = this.listPosts.find(function(element) {
            return element._id === id && element.page[0].network === 'instagram'
          })
        }
        this.editPost.id = post._id
        this.overlayState = 'inqueue-edit'
        this.overlayItem = post
        this.overlayPage = pages
        if(post.preview_date){
          let day = moment(post.preview_date).local().hours(0).minutes(0).seconds(0)
          let hour = moment(post.preview_date).local().hours()
          let minute = moment(post.preview_date).local().minutes()
          this.displayOverlay(false, day, hour, minute)
        }
        else if(slotDate){
          let day = moment(slotDate).local().hours(0).minutes(0).seconds(0)
          let hour = moment(slotDate).local().hours()
          let minute = moment(slotDate).local().minutes()
          this.displayOverlay(false, day, hour, minute)
        }
        else 
          this.displayOverlay()
      } else {
        let post = this.listPosts.find(function(element) {
          return element._id === id
        })
        if (this.listPosts.filter(element => element._id === id).length > 1 && post.page && post.page[0] && post.page[0].network === 'facebook' && post.page[0].storification) {
          post = this.listPosts.find(function(element) {
            return element._id === id && element.page[0].network === 'instagram'
          })
        }
        console.log(post)
        let draft = post.page && post.page[0] && post.page[0].draft ? JSON.parse(post.page[0].draft) : null
       
        if (draft && draft.saveAllFormData) {
          
          let posts = post.page[0].posts_multipages ? post.page[0].posts_multipages : null

          if (!posts || !posts.length) {
            posts = [{
              _id: post.id,
              id: post.id,
              bot: post._bots[0].id,
              page: post._bots[0].page.id,
              postId: post.page[0].post_number,
              status: post.status,
            }]
          }

          this.$store.commit('postCreator/setDataForEditPost', {
            draft: draft,
            posts,
            post
          });
          this.$router.push('/dash/postCreator/edit');
        }else{
          this.editPost.id = post.id
          this.overlayState = 'edit'
          if (status === 'posted' && post.page[0].post_number) {
            this.overlayState = 'edit-posted'
          }
          this.overlayItem = post
          this.overlayPage = pages
          let clean = false
          let day = moment(post.page[0].scheduled_date).local().hours(0).minutes(0).seconds(0)
          let hour = moment(post.page[0].scheduled_date).local().hours()
          let minute = moment(post.page[0].scheduled_date).local().minutes()
          
          if(draft)
            this.overlayPages = draft.bot.filter(bId => this.bots.find(b => b.id == bId)).map(bId => this.bots.find(b => b.id == bId).page.id)

          this.displayOverlay(clean, day, hour, minute)
        }  
      }
    },

    duplicatePost(page, post, unique=false) {
      console.log("duplicate",{page, post, unique})
      
      if(!['Admin', 'Editor', 'Writter'].includes(this.getUserRole)) return
      let draft = post.page && post.page[0] && post.page[0].draft ? JSON.parse(post.page[0].draft) : post.draft && post.draft.data ? post.draft && post.draft.data : null

      if (draft && draft.saveAllFormData) {
        this.$store.commit('postCreator/setDataForDuplicatePost', {
            draft: draft,
            pages: !unique && post.page[0].posts_multipages && post.page[0].posts_multipages.length > 1 ? post.page[0].posts_multipages.map(post => post.page) : [page]
        });
        this.$router.push('/dash/postCreator/duplicate');
      }else{
        this.close()
        this.closePostsOverlay = false

        console.log('duplicate post', post)

        this.editPost.id = post._id
        this.overlayState = `duplicate-post${unique ? '-unique' : ''}`
        this.overlayItem = post
        this.overlayPage = page

        if(unique)
          this.overlayPages = [page]
        else if(post && post.page && post.page[0] && post.page[0].draft)
            this.overlayPages = JSON.parse(post.page[0].draft).bot.filter(bId => this.bots.find(b => b.id == bId)).map(bId => this.bots.find(b => b.id == bId).page.id)


        this.displayOverlay()

      }


    },

    shareToStory(pages, id, media) {
      this.close()
      this.closePostsOverlay = false

      console.log("shareStory", pages, id, media);

      let post = this.listPosts.find(function(element) {
        return element._id === id
      })
      this.editPost.id = post.id
      this.overlayState = 'share-story'
      this.overlayItem = post
      this.overlayPage = pages
      if(post && post.page && post.page[0] && post.page[0].draft) {
          this.overlayPages = JSON.parse(post.page[0].draft).bot.filter(bId => this.bots.find(b => b.id == bId)).map(bId => this.bots.find(b => b.id == bId).page.id)
      }
      this.overlayPages = this.overlayPages.filter(p => this.selectedPages.find(sp => sp.id === p).network === 'instagram');
      this.$nextTick(() => {
        let share2 = media.split("_")[0]
        let share1 = media.split("_")[1]
        let share3 = this.findPage(pages).name
        console.log(`$_$:${share1}:${share2}:${share3}`);
        this.shareStory = `$_$:${share1}:${share2}:${share3}`;
        this.displayOverlay()
      })
    },

    resharePost(pageId, newsId, pageEmbed){
      this.close()
      this.closePostsOverlay = false

      let post = this.listPosts.find(function(element) {
        return element._id === newsId
      })
      this.editPost.id = post._id
      this.overlayState = 'reshare'
      this.overlayItem = post
      this.overlayPage = pageId
      this.popup.title = this.$t('dash.posts.reshare')
      this.displayOverlay()
    },

    retweetPost(pageId, newsId, pageEmbed){
      this.close()
      this.closePostsOverlay = false

      let post = this.listPosts.find(function(element) {
        return element._id === newsId
      })
      this.editPost.id = post._id
      this.overlayState = 'retweet'
      this.overlayItem = post
      this.overlayPage = pageId
      this.popup.title = this.$t('dash.posts.retweet')
      this.displayOverlay()
    },
    retweetPostOLD(bot, news_id, retweet_id, unretweet=false){
      let body = {bot, news_id, retweet_id, unretweet}
      this.refresh.enabled = false

      this.$vs.loading({color : 'primary', text: this.$t('dash.post.loading.text')})

      this.newRetweet(body).then(res => {
        this.$vs.loading.close()
        
        const { source, news, post, success } = res.body

        if(this.activeLog){
          let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'retweet-post', messageLog)
        }
      })
      
    },

    /**
     * Post update
     * @param {Object} body - post body
     */
    update: function(body) {
      console.log('update function', body)
      this.refresh.enabled = false
      
      let nbPosts = body.nbPosts
      delete body.nbPosts
      this.totalPost = nbPosts

      let storyIdentification = body.storyIdentification
      delete body.storyIdentification
      this.showAdd = false

      this.hidePostOverlay = true
      this.showRecap = true
      let indexRecapOriginal = this.recap.findIndex(post => post.pageEmbed && post.pageEmbed.post_number == body.postId && post.bot == body.bot)
      if(indexRecapOriginal >= 0)
        this.recap.splice(indexRecapOriginal, 1);
      this.recap.push({ ...body, status: 'posting' })
      this.updateRecap()
      let indexRecap = this.recap.length - 1

      let idPost = body.id
      this.putPost(body).then(res => {
        this.countCurrentMultiplePosts++
        const { success } = res.body
        console.log('res.body', res.body)
        if(this.activeLog){
          let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'update-post', messageLog)
        }

        if (!success || success !== true || (body.data.editPostAlreadyPosted && !res.body.post.success)) {
          this.$set(this.recap[indexRecap], 'status', 'error')
          this.updateRecap()
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            this.dialog.message = res.body.statusText
          }
          this.dialog.show = true
          return
        }

        const bot = this.bots.find(b => b.id == body.bot)
        // prepare page object
        let page = {
          id: bot.uid, 
          is_dashboard: true, 
          is_manual_post: true, 
          network: bot.page.network, 
          post_number: res.body.post.post,
          status: 1, 
          utm: bot.utm_source,
        }
        page['scheduled_date'] = body.data.scheduled_date

        this.popup.title = this.$t('dash.posts.scheduled.title')
        this.popup.content = this.$t('dash.posts.scheduled.description')

        this.currentPosted.push({
          _id: idPost,
          bot: bot.id,
          page: bot.page.id,
          network: bot.network,
          postId: page.post_number, 
          status: page.status,
          story: storyIdentification
        })

        if(this.countCurrentMultiplePosts == nbPosts) {
          this.popup.validated = true
          this.refresh.enabled = true
          this.close()
          
          if(this.currentPosted.length > 1){
            console.log('edit posts multi-page terminé', this.currentPosted)
            this.selectedPages = this.linked.filter(p => this.currentPosted.map(c => c.page).includes(p.id))
            // save currentPosted list on each news
            this.updatePostsMultiPages(this.currentPosted)
            this.currentPosted.forEach(currentP => {
              let indexP = this.listPosts.findIndex(p => p.id == currentP._id)
              if(indexP >= 0)
                this.listPosts[indexP].page[0].posts_multipages = this.currentPosted
            })

            // this.currentPosted = []
            // this.countCurrentMultiplePosts = 0
          }
          localStorage.removeItem('postingInProgress')
        }
        else if(nbPosts == 1){
          this.popup.validated = true
          this.refresh.enabled = true
          this.close()
          this.selectedPages = this.linked.filter(p => this.currentPosted.map(c => c.page).includes(p.id))
          // this.currentPosted = []
          // this.countCurrentMultiplePosts = 0
          localStorage.removeItem('postingInProgress')
        }
        console.log('indexRecap', indexRecap, this.recap[indexRecap]);
        

        this.$set(this.recap[indexRecap], 'status', body.data.editPostAlreadyPosted ? 'posted' : 'scheduled')
        this.$set(this.recap[indexRecap], 'pageEmbed', page)
        this.updateRecap()
      })
      .then(() => {
        this.filter = ['all']
        setTimeout(() => this.reloadDataCalendar(), 1000)
        if(nbPosts == 1 || !nbPosts || (nbPosts > 1 && this.countCurrentMultiplePosts == nbPosts)) {
          this.currentPosted = []
          this.countCurrentMultiplePosts = 0
          this.totalPost = 0
          this.close()
          setTimeout(() => this.reloadDataCalendar(), 1000)  
        }
        this.$emit('disclaimer-post', false)
      })
    },

    add: function(body) {
      this.$emit('disclaimer-post', true)
      console.log('function add',body, body.nbPosts, body.storyIdentification)
      const bot = this.bots.find(b => b.id == body.bot);
      let last = body.last
      delete body.last
      let nbPosts = body.nbPosts
      delete body.nbPosts
      this.totalPost = nbPosts

      let storyIdentification = body.storyIdentification
      delete body.storyIdentification

      this.showAdd = false

      this.hidePostOverlay = true
      this.showRecap = true
      let storificationObject = body.data.storification ? JSON.parse(body.data.storification) : null;
      console.log(storificationObject);
      const storification = (storificationObject && storificationObject.facebook) ? 'all' : ((body.data.story_instagram && body.data.story_instagram[0] && body.data.story_instagram[0].shareToFacebook)) ? 'facebook' : (body.data.storification ? 'instagram' : null)
      let storification_date = storificationObject && storificationObject.scheduling ? moment(storificationObject.scheduling).toISOString() :moment(body.data.scheduled_date).add(1, 'minute').toISOString()
      this.recap.push({ ...body, status: 'posting', storification, storification_date})
      this.updateRecap()
      let indexRecap = this.recap.length - 1

      this.refresh.enabled = false
      if ((body.data.story_instagram || body.data.typePost === "story") && !body.scheduled) {
          this.$nextTick(() => {
            this.$vs.notify({time: 10000, title:'Post en cours',text:'Le post est en cours, il sera posté dans maximum 5 minutes'});
            this.close()
          });
      }
      // if ((bot.page.network === 'tiktok' && body.data.typePost === "video")) {
      //     this.$nextTick(() => {
      //       this.$vs.notify({time: 10000, title:this.$t("dash.posts.tiktok.upload.explain.title"),text:this.$t("dash.posts.tiktok.upload.explain.content")});
      //       this.close()
      //     });
      // }

      if(nbPosts > 1) {
        if(!this.selectedPages.find(p => p && p.id == this.bots.find(b => b.id == body.bot).page.id))
          this.selectedPages.push(this.linked.find(p => this.bots.find(b => b.id == body.bot).page.id == p.id))
      } 
      else if(nbPosts == 1){
        this.selectedPages = this.linked.filter(p => this.bots.find(b => b.id == body.bot).page.id == p.id)
      }

      // eslint-disable-next-line no-constant-condition
      this.newPost(body).then(res => {
        this.countCurrentMultiplePosts++
        let stopError = false
        let indexPage, indexPost
        console.log('res',res)
        const { source, news, post, success, error, message } = res.body
        let story = news && news.page && news.page[0] 
                      ? news.page[0].story 
                      : post 
                          ? post.story 
                          : null

        if(this.activeLog){
          let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'create-post', messageLog)
        }

        const bot = this.bots.find(b => b.id == body.bot)
        console.log('post.success', post)
        if(post && !post.success && body.data.video && bot.page.network != 'linkedin') {
          const notif = {
            time: 10000,
            color:'primary',
            title: this.$t('dash.posts.error.title'),
            text: bot.page.network == 'facebook' 
                  ? this.$t('dash.posts.error.video.facebook')
                  : bot.page.network == 'twitter'
                    ? this.$t('dash.posts.error.video.twitter')
                    : bot.page.network == 'instagram'
                      ? this.$t('dash.posts.error.video.instagram')
                      : this.$t('dash.posts.error.description')
          }
          this.$set(this.recap[indexRecap], 'status', 'error')
          this.$set(this.recap[indexRecap], 'error', notif.text)
          this.updateRecap()
          stopError = true
        }
        
        else if ((news && !news.id) || !success || (post && (!post.success || post.post == "duplicate"))) {
            const notif = {
              time: 10000,
              color:'primary',
              title: this.$t('dash.posts.error.title'),
              text: post && (post.post == 'duplicate' || (post.error && ((post.error.message && post.error.message.includes('already posted')) || (typeof post.error === 'string' && post.error.includes('already posted')))))
                ? this.$t('dash.posts.error.already_posted')
                : bot.page.network == 'instagram' && post
                  ? post.error.message || post.error
                  : (post ? post.error.message || post.error : (message ? message : this.$t('dash.posts.error.description')))
            }
            this.$set(this.recap[indexRecap], 'status', 'error')
            this.$set(this.recap[indexRecap], 'error', notif.text)
            this.updateRecap()
            stopError = true
        }

        else if(!success && error){
          this.$set(this.recap[indexRecap], 'status', 'error')
          this.$set(this.recap[indexRecap], 'error', error)
          this.updateRecap()
          stopError = true
        }

        else {

          indexPage = this.linked.findIndex(p => p.id == bot.page.id)
          console.log('indexPage', indexPage)
          console.log('body.data',body.data);
          console.log('post',post);
  
          //get index news to modify else new/add news
          indexPost = this.listPosts.findIndex(p => p.id == body.data.id)
          // prepare page object
          let page = {
            id: bot.uid, 
            is_dashboard: true, 
            is_manual_post: true, 
            network: bot.page.network, 
            post_number: post.post, 
            post_number_bis: post.post_bis, 
            status: body.scheduled ? 1 : 2, 
            utm: bot.utm_source,
            enclosure : body.data.enclosure && body.data.enclosure != news.enclosure ? news.enclosure : null,
            story: post.story,
            carousel: body.data.carrousel,
            multipleMedias: body.data.multipleMedias
          }
          if(body.scheduled) page['scheduled_date'] = body.data.scheduled_date
          else page['posted_date'] = body.data.scheduled_date
  
          if(!page.enclosure && body.data.postImage) page.enclosure = news.enclosure
  
          if(body.data.is_reshare){
            page.is_reshare = body.data.is_reshare
            page.reshare_message = body.data.reshare_message
            page.news_url = body.data.news_url
          }
          else if(body.data.is_retweet){
            page.is_retweet = body.data.is_retweet
            page.retweet_id = body.data.retweet_id
          }
          
            console.log('news.page', page)
  
          //add new post
          if(indexPost == -1){
            news._id = news.id
            news._bots = [bot]
            news.page = [page]
            news.status = page.status
            news.page[0].story = story
            console.log('news', news, story)
            this.listPosts.unshift(news)
          }
          //modify post
          else {
            this.listPosts[indexPost].page.push(page)
            this.listPosts[indexPost].status = page.status 
            this.listPosts[indexPost].id = news.id 
            this.listPosts[indexPost]._id = news.id 
          }
  
          if(body.data.original){
            let indexPostOriginal = this.listPosts.findIndex(p => p.id == body.data.original)
            this.listPosts.splice(indexPostOriginal, 1)
          }
  
          this.sources.push(source)
  
          if(body.scheduled){
            this.popup.title = this.$t('dash.posts.scheduled.title')
            this.popup.content = this.$t('dash.posts.scheduled.description')
          }else{
            this.popup.title = this.$t('dash.posts.confirmation.title')
            this.popup.content = this.$t('dash.posts.confirmation.description')
          }
  
          if(this.isDeleteSlot){
            //TODO : delete slot
            this.isDeleteSlot = false
          }
  
          this.currentPosted.push({
            _id: news.id,
            bot: bot.id,
            page: bot.page.id,
            network: bot.network,
            postId: post.post, 
            status: page.status,
            direct: post.post_bis,
            story: storyIdentification
          })

          this.$set(this.recap[indexRecap], 'status', body.scheduled ? 'scheduled' : 'posted')
          this.$set(this.recap[indexRecap], 'pageEmbed', page)
          this.recap[indexRecap].data.id = news.id
          this.updateRecap()
        }

        if(nbPosts > 1 && this.countCurrentMultiplePosts == nbPosts) {
          this.popup.validated = true
          this.refresh.enabled = true
          this.close()

          if(this.currentPosted.length > 1){
            console.log('posts multi-page terminé', this.currentPosted)
            // this.selectedPages = this.linked.filter(p => this.currentPosted.map(c => c.page).includes(p.id))
            this.updateSelected(0)
            // save currentPosted list on each news
            this.updatePostsMultiPages(this.currentPosted)
            this.currentPosted.forEach(currentP => {
              let indexP = this.listPosts.findIndex(p => p.id == currentP._id)
              if(indexP >= 0)
                this.listPosts[indexP].page[0].posts_multipages = this.currentPosted
            })

            // this.currentPosted = []
            // this.countCurrentMultiplePosts = 0
          }
          localStorage.removeItem('postingInProgress')
        } 
        else if(nbPosts == 1 || !nbPosts){
          // this.selectedPages = this.linked.filter(p => this.currentPosted.map(c => c.page).includes(p.id))
          this.updateSelected(0)
          // this.currentPosted = []
          // this.countCurrentMultiplePosts = 0
          localStorage.removeItem('postingInProgress')
        }

        if(stopError) {
          this.updateRecap()
          return
        }
        
      })
      .then(() => {
        if(nbPosts == 1 || !nbPosts || (nbPosts > 1 && this.countCurrentMultiplePosts == nbPosts)) {
          this.currentPosted = []
          this.countCurrentMultiplePosts = 0
          this.totalPost = 0
          this.close()
          this.filter = ['all']
          setTimeout(() => this.reloadDataCalendar(), 1000)  
        }
        this.$emit('disclaimer-post', false)
      })
    },

    addWithoutBot: function(body) {
      this.showLoader = true
      this.newPostWithoutBot(body).then(res => {
        console.log('add response', res)

        this.showLoader = false
        const { news, post, success } = res.body

        if(this.activeLog){
          let messageLog = `${res.url} --- ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'create-post-without-bot', messageLog)
        }

        if (!success) {
          const notif = {
            time: 10000,
            color:'primary',
            title: this.$t('dash.posts.error.title'),
            text: post.error && post.error.includes('already posted')
              ? this.$t('dash.posts.error.already_posted')
              : this.$t('dash.posts.error.description')
          }
          this.$vs.notify(notif)
          return
        }

        this.overlayItem = news

        if(body.scheduled){
          this.popup.title = this.$t('dash.posts.scheduled.title')
          this.popup.content = this.$t('dash.posts.scheduled.description')
        }else{
          this.popup.title = this.$t('dash.posts.confirmation.title')
          this.popup.content = this.$t('dash.posts.confirmation.description')
        }

        this.popup.validated = true
      })
    },

    deleteScheduled(post, overlay=false) {

      this.showRecap = true
      let indexRecapOriginal = this.recap.findIndex(p => p.pageEmbed && p.pageEmbed.post_number == post.page[0].post_number)
      if(indexRecapOriginal >= 0)
        this.recap.splice(indexRecapOriginal, 1);
      this.recap.push({
                        bot: post._bots[0] ? post._bots[0].id : post._bots.id, 
                        data: {
                          deleted_date: moment().format(),
                          title: post.title
                        },
                        status: 'deleting' 
                      })
      this.updateRecap()
      let indexRecap = this.recap.length - 1

      this.deletePost(post).then(res => {
        const { success } = res.body

        if(this.activeLog){
          let messageLog = `${res.url} --- ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'delete-scheduled-post', messageLog)
        }

        if (!success || success !== true) {
          this.$set(this.recap[indexRecap], 'status', 'error')
          this.$set(this.recap[indexRecap], 'error', this.$t('dash.posts.error.description'))
        }

        let indexPost = this.posts[this.indexPage].posts.findIndex(p => p.id == post.id)
        if(!overlay && indexPost >= 0)
          this.posts[this.indexPage].posts.splice(indexPost, 1)        
        
        this.recap[indexRecap].status = 'deleted' 
      })
      .then(() => {
        if(!overlay){
          if(this.activeSection == 'calendar') setTimeout(this.reloadDataCalendar, 1000)
          else setTimeout(this.retrievePosts(this.selectedTab, this.linked[this.selectedTab].id), 1000)
        }
      })
    },

    removeDrafts(id){
      let indexPost = this.posts[this.indexPage].posts.findIndex(p => p.id == id)
      this.posts[this.indexPage].posts.splice(indexPost, 1) 
      
      let pageId = this.linked[this.selectedTab].id
      this.retrievePosts(this.selectedTab, pageId)
    },

    close: function() {
      this.popup.validated = false
      this.popup.title = 'Post'
      this.showAdd = false
      this.activeOptimalTimes=false

      this.post = null

      // clean
      this.overlayState = 'new'
      this.overlayItem = null
      this.overlayPage = null 
      this.overlayPages = null 
      this.scheduledOverlay.day = null
      this.scheduledOverlay.hour = null
      this.shareStory = null

      this.closePostsOverlay = true
    },

    minimizeRecap(){
      this.showRecap = false
    },

    maximizeRecap(){
      if(!this.showRecap)
        this.showRecap = true
    },

    removeRecap() {
      this.showRecap = false
      this.recap = []
      this.updateRecap()
    },

    async fetchPages() {
      return this.getPages()
                  .then(res => {
                    const { pages } = res.body
                    localStorage.setItem('pages', JSON.stringify(pages))
                  })
    },

    async getListPages() {
      this.getBots()
      if(!(localStorage.pages && JSON.parse(localStorage.pages)))
        await this.fetchPages()
      let linkedPages = JSON.parse(localStorage.pages)
      new Promise((resolve, reject) => {
        linkedPages = linkedPages.slice().sort((a,b) => {
          if(
              (
                this.bots.some(bot => bot.page.id == a.id) 
                && 
                this.bots.some(bot => bot.page.id == b.id)
              )
              || 
              (
                !this.bots.find(bot => bot.page.id != a.id) 
                && 
                !this.bots.find(bot => bot.page.id != b.id)
              )
            ){
            return (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0)
          }
          else if(this.bots.some(bot => bot.page.id == a.id)){
            return -1
          }
          else if(this.bots.some(bot => bot.page.id == b.id)){
            return 1
          }
        })
        resolve()
      })
      .then(() => {
        //sort by bots updated_at
        linkedPages = linkedPages.slice().sort((a,b) => {
          let botsA = this.bots.filter(bot => bot.page.id == a.id).sort((aB,bB) => (aB.updated_at < bB.updated_at) ? 1 : ((aB.updated_at > bB.updated_at) ? -1 : 0))
          let botsB = this.bots.filter(bot => bot.page.id == b.id).sort((aB,bB) => (aB.updated_at < bB.updated_at) ? 1 : ((aB.updated_at > bB.updated_at) ? -1 : 0))
          if(botsA.length == 0 && botsB.length == 0) return 0 
          else if(botsA.length > 0 && botsB.length == 0) return -1
          else if(botsA.length == 0 && botsB.length > 0) return 1
          else if(botsA[0].updated_at < botsB[0].updated_at) return 1
          else if(botsA[0].updated_at > botsB[0].updated_at) return -1
          else return 0
        })
        this.linked = linkedPages.slice()

        if(this.user && this.user.role && this.user.role.length && this.user.role[0] === 'Viewer') {
          this.selectedPages = this.linked
          this.selectedTab = 0
        }
      })
    },

    //function to concat uniq mentions on each bots page's
    async checkBotsMentions(){

      let uniq = a => [...new Set(a)];

      for(let botIndex in this.bots) {
        let bot = this.bots[botIndex]
        if(!bot.mentions || !bot.mentions.length) bot.mentions = []
        let bots = this.bots.filter(b => b.page.id == bot.page.id && b.id != bot.id)
        for(let b of bots)
          if(b.mentions && b.mentions.length)
            bot.mentions = uniq(bot.mentions.concat(b.mentions))
        this.$set(this.bots[botIndex], 'mentions', bot.mentions)
      }
    },

    /**
     * Retrieve bots from database and cache them.
     */
      async fetchBots() {
      try {
        // Get bot list from server
        const { body, statusText } = await this.getAllBots({})
        const { success, bots } = body
        if (!success) {
          throw Error(statusText)
        }
      
        this.bots = bots
        localStorage.setItem('bots', JSON.stringify(bots))

        // Save data
      } catch (err) {
        return this.handleError(err)
      }
    },

    async getBots() {
      if(localStorage.bots && JSON.parse(localStorage.bots))
        this.bots = JSON.parse(localStorage.bots)
      else
        await this.fetchBots()
      
      await this.checkBotsMentions()

      // try {
      //   const { body, statusText } = await this.getAllBots({})
      //   const { success, bots } = body
      //   if (!success) {
      //     throw Error(statusText)
      //   }
      //   this.bots = bots
      //   await this.checkBotsMentions()
      //   await localStorage.setItem('bots', JSON.stringify(bots))
      // } catch (err) {
      //   return this.handleError(err)
      // }
    },

    arrayPostsFilter(isExport=false) {
      console.log('arrayPostsFilter function', this.filter)
      let tmp = []
      let filter = isExport ? this.filterExport : this.filter 

      if (filter.includes('all')) tmp = this.postsTmp.filter(post => (post.page.length > 0 && post.page[0].status == -1) == false)
      else {
        if (filter.includes('draft'))
          tmp = tmp.concat(this.postsTmp.filter(post => post.draft && (post.page.length > 0 && post.page[0].status == -1) == false))
        if (filter.includes('queue')) 
          tmp = tmp.concat(this.postsTmp.filter(post => post.page.length == 0 && !post.draft))
        if (filter.includes('scheduled')) 
          tmp = tmp.concat(this.postsTmp.filter(post => post.page.length > 0 && post.page[0].status == 1 && post.page[0].scheduled_date >= new Date().toISOString()))
        if (filter.includes('posted'))
          tmp = tmp.concat(this.postsTmp.filter(post => post.page.length > 0 && (
            post.page[0].status == 2 || 
            (post.page[0].status == 1 && post.page[0].scheduled_date < new Date().toISOString())
          )))
        if (filter.includes('failed')) 
          tmp = tmp.concat(this.postsTmp.filter(post => post.page.length > 0 && post.page[0].status == 4))
        if (filter.includes('removed')) 
          tmp = tmp.concat(this.postsTmp.filter(post => post.page.length > 0 && post.page[0].status == -1))
        if (filter.includes('direct')) 
          tmp = tmp.concat(this.postsTmp.filter(post => post.status && post.status == 'direct'))
      } 
      
      if(isExport) this.updatePostsToExport(tmp)
      else{
        for (let key in tmp) {
          let status

          if (tmp[key].page && tmp[key].page.length > 0 && (!tmp[key].draft || tmp[key].page[0].status === -1)) {
            if (tmp[key].page[0].status === 2) {
              status = 2
            } else if(tmp[key].page[0].status === 1 && moment.min(moment(tmp[key].page[0].scheduled_date), moment(moment().add(-5, 'minutes'))).format() == moment(moment().add(-5, 'minutes')).format()) {
              status = 1
            } else if (tmp[key].page[0].status === -1) {
              status = -1
            } else {
              status = 4
            }
          } else {
            status = 0
            if(tmp[key].draft)
              status = 6
          }
          tmp[key]['status'] = status

        }

        this.listPosts = tmp
      }
        
      
    },

    getMorePosts() {
      //à revoir pour utiliser le sst de vuesax (pagination)
      this.nbPostsToGet += NB_POSTS_TO_GET
      let pageId = this.linked[this.selectedTab].id
      this.retrievePosts(this.selectedTab, pageId)
      this.arrayPostsFilter()
    },

    reloadDataCalendar(startDate, endDate){
      if(this.waitGetCalendar && startDate && endDate) this.waitGetCalendar = false
      if(!this.waitGetCalendar) {
        if(this.selectedPages.length == 0) {
          this.listPosts = null
          this.weeklyPlanner = null
          this.monthlyPlanner = null
        }
        else {
          console.log('reloadDataCalendar')
            this.retrievePosts(this.selectedTab, startDate, endDate)
            this.arrayPostsFilter()
        }
      }
    },

    excludeNews(bot, post){
      console.log('posts excludeNews', bot,post)
      let indexPost = this.posts[this.indexPage].posts.findIndex(p => p.id == post.id)
      let page = {
        id: bot.uid, 
        is_dashboard: true, 
        is_manual_post: true, 
        network: null, 
        post_number: null, 
        status: 0, 
        utm: bot.utm_source
      }
      this.posts[this.indexPage].posts[indexPost].page.push(page) 
      
      if(this.activeSection == 'calendar') setTimeout(this.reloadDataCalendar, 1000)
      else setTimeout(this.retrievePosts(this.selectedTab, this.linked[this.selectedTab].id), 1000)
    },

    openLoader(bool){
      this.showLoader = bool
    },

    filterPosts(changeSelectedPages=null) {
      if(changeSelectedPages)
        this.selectedPages = this.linked.filter(p => this.bots.filter(b => b.page.id == p.id).some(b => changeSelectedPages.includes(b.id)))

      let pageId = this.linked[this.selectedTab].id
      if(this.activeSection == 'calendar'){
        this.$set(this.posts[this.selectedTab], 'posts', [])
        this.postsTmp = []
        this.indexPage = this.selectedTab
        this.retrievePosts(this.selectedTab, pageId)
      }
      else
        this.retrievePosts(this.selectedTab, pageId)
    },

    retrievePosts(index, id, startDate=null, endDate=null, refreshPages=false) {
      console.log('retrievePosts')
      if(this.activeSection == 'calendar' && (!startDate || !endDate)){
        startDate = this.startDate
        endDate= moment(startDate).add(6, 'days').hour(23).minute(59).second(59)
      }

      if(refreshPages) {
        new Promise(async (resolve, reject) => {
          // await this.fetchGroups()
          this.fetchGroups()
          resolve()
        })
        .then(this.fetchPages)
        .then(this.getListPages)
        .then(this.fetchBots)
        .then(() => {
          // Get bots
          this.getBots()
        })
      }


      const callback = (res) => {
        const { success, posts, calendar, monthlyCalendar } = res.body

        // if(this.activeLog){
        //   let tenInQueue = posts.filter(p => p.page.length == 0 ).map(p => p.url).slice(0,5)
        //   let messageLog = `${res.url} --- id: ${id} --- status: ${status} --- in-queue: ${JSON.stringify(tenInQueue)}`
        //   this.addLog(JSON.parse(localStorage.user), 'list-posts', messageLog)
        //   let tenPosted = posts.filter(p => p.page.length > 0 && p.page[0].status === 2).map(p => p.url).slice(0,5)
        //   messageLog = `${res.url} --- id: ${id} --- status: ${status} --- posted: ${JSON.stringify(tenPosted)}`
        //   this.addLog(JSON.parse(localStorage.user), 'list-posts', messageLog)
        //   let tenScheduled = posts.filter(p => p.page.length > 0 && p.page[0].status === 1).map(p => p.url).slice(0,5)
        //   messageLog = `${res.url} --- id: ${id} --- status: ${status} --- scheduled: ${JSON.stringify(tenScheduled)}`
        //   this.addLog(JSON.parse(localStorage.user), 'list-posts', messageLog)
        // }

        if (!success || success !== true) {
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            this.dialog.message = res.body.statusText
          }
          this.dialog.show = true
          return
        }

        let postAdded = [];

        for (let key in posts) {
          let status

          if (posts[key].page && posts[key].page.length > 0) {
            if (posts[key].page[0].status === 2) {
              status = 2
            } else if (posts[key].page[0].status === 3) {
              status = 3
            } else if (posts[key].page[0].status === 4) {
              status = 4
            } else if (posts[key].page[0].status === 5) {
              status = 5
            } else if (posts[key].page[0].status === 6) {
              status = 6
            } else if (posts[key].page[0].status === -1) {
              status = -1
            } else {
              status = 1
            }
          } else {
            status = 0
          }
          posts[key]['status'] = status

          if(this.filter === 'posted' && status == 2 && posts[key]._bots[0].type == 'facebook' && this.activeSection != 'calendar'){
            //fix id post_number
            if(posts[key].page && posts[key].page[0] && posts[key].page[0].post_number && !posts[key].page[0].post_number.includes('_'))
              posts[key].page[0].post_number = `${posts[key]._bots[0].page.network_id}_${posts[key].page[0].post_number}`
            this.queue = new Queuer({
              data: JSON.parse(JSON.stringify(posts)),
              task:(post) => {
                this.processInsights(post, index)
              }
            })

            this.queue.init()
          }

          if (posts[key].page && posts[key].page.length > 1 && posts[key].page.filter(e => e && e.network === 'instagram').length >= 2
          && posts[key].page.filter(e => e && e.network === 'instagram').some(e => e && e.storification)) {
            let postotoadd, postotoadd2;
            let fbpage = posts[key].page.find(e => e && e.network === "facebook");
            const indexStorification = posts[key].page.findIndex(e => e && e.network === 'instagram' && e.storification);
            const indexNoStorification = posts[key].page.findIndex(e => e && e.network === 'instagram' && !e.storification);
            postotoadd = JSON.parse(JSON.stringify(posts[key]));
            postotoadd.page[0] = posts[key].page[indexStorification];
            postotoadd.page[indexNoStorification] = null;
            posts[key].page[indexStorification] = null;
            posts[key].page[0] = posts[key].page[indexNoStorification]
            posts[key]._bots = [posts[key]._bots.find(e => e && e.type === 'instagram')]
            // if (fbpage && this.selectedPages.filter(e => e.network === 'facebook' && e.id === fbpage.id).length > 0 && fbpage.storification) {
            //   postotoadd2 = JSON.parse(JSON.stringify(posts[key]));
            //   postotoadd2.page = postotoadd2.page.filter(e => e.network === 'facebook');
            //   console.log(postotoadd2);
            //   postAdded.push(postotoadd2)
            // }
            postAdded.push(postotoadd)
          }
        }
        for (let pta of postAdded.reverse()) {
            posts.unshift(pta)
            if (calendar) {
              let dateP = pta.page[0].scheduled_date.split("T");
              let dayP = dateP[0]
              let hourP = parseInt(dateP[1].split(':')[0])
              let idxCalendar = Object.entries(calendar).find(e => e[1].day.startsWith(dayP))
              let creneauP = calendar[idxCalendar[0]].slots.find(e => e && e.filter(ee => ee.id === pta.id).length > 0);
              creneauP.find(e => e.id === pta.id).page = creneauP.find(e => e.id === pta.id).page.filter(e => !(e.network === 'instagram' && e.storification))
              creneauP.push({...pta, status: "scheduled"});
            }
            if (monthlyCalendar) {
              let dateP = pta.page[0].scheduled_date.split("T");
              let dateMP = dateP[0].split('-').reverse().join('/');
              let idxCalendar = monthlyCalendar.find(e => e.date === dateMP)
              idxCalendar.posts.find(e => e.id === pta.id).page = idxCalendar.posts.find(e => e.id === pta.id).page.filter(e => !(e.network === 'instagram' && e.storification))
              idxCalendar.posts.push({...pta, status: "scheduled"});
              console.log(idxCalendar);
            }
        }
        this.$set(this.posts[index], 'posts', posts)
        const fiveMinutesAgoUnixTime = moment().subtract(5, 'minutes').second(0).unix()
        this.listPosts = posts.map(p => {
          if(!p.draft && p.page && p.page.length && p.page[0].status == 1 && p.page[0].scheduled_date && moment(p.page[0].scheduled_date).unix() < fiveMinutesAgoUnixTime) {
            p.status = 5
            p.page[0].status = 5
          }
          return p
        })
        if(calendar) this.$set(this.posts[index], 'calendar', calendar)
        else this.$set(this.posts[index], 'calendar', null)
        if(calendar) this.weeklyPlanner = calendar
        else this.weeklyPlanner = null

        if(monthlyCalendar) this.$set(this.posts[index], 'monthlyCalendar', monthlyCalendar)
        else this.$set(this.posts[index], 'monthlyCalendar', null)
        if(monthlyCalendar) this.monthlyPlanner = monthlyCalendar
        else this.monthlyPlanner = null
        this.postsTmp = posts
        this.indexPage = index
      }

      // this.showLoader = true
      //stop loader on timeout 20sec
      // setTimeout( ()=> {
      //   this.showLoader = false
      // }, 20000);





      // this.postsByPages(this.selectedPages.map(p => p.id).toString(), this.nbPostsToGet, startDate, endDate, this.activeSection == 'calendar' && this.monthly, this.selectedPages.length == this.posts.filter(p => !(!this.checkLock(p.pages.network) || (!this.isUserPremiumActive && this.posts[0].pages.id !== p.pages.id && !this.isUserPartner))).length)
      //   .then(callback)
      //   .then(() => this.showLoader = false)
      //   .then(() => this.nextComponent = true)

      if(this.eventSource){
        this.eventSource.close();
        this.eventSource = null
        this.percentLoader = 0
      }
      this.showLoader = true

      this.eventSource = this.postsByPagesPercent(this.selectedPages.map(p => p.id).toString(), this.nbPostsToGet, startDate, endDate, this.activeSection == 'calendar' && this.monthly, this.selectedPages.length == this.posts.filter(p => !(!this.checkLock(p.pages.network) || (!this.isUserPremiumActive && this.posts[0].pages.id !== p.pages.id && !this.isUserPartner))).length)
      this.eventSource.onopen = () => {
        this.percentLoader = 0
        console.log("opened");
        this.$forceUpdate();
      };
      this.eventSource.onerror = (error) => {
        this.percentLoader = 0
        this.showLoader = false
        console.log("error", error);
        this.eventSource.close();
        this.eventSource = null
        this.$forceUpdate();
      };

      this.eventSource.onmessage = (event) => {
        
        let eventData = JSON.parse(event.data)
        // console.log('percent', eventData.percent)
        this.percentLoader = eventData.percent
        this.$forceUpdate();
        console.log('percent', eventData.percent, this.percentLoader)
        if(eventData.percent == 100 && eventData.result){
          callback({body: eventData.result})

          // reporting posts
          /*
          console.log('eventData.result', eventData.result)
          let postsReporting = [...eventData.result.posts]
          let botss = JSON.parse(localStorage.bots)
          const getNamePageById = (pageId) => botss.find(b => b.uid == pageId).page.name
          const getNetworkPageById = (pageId) => botss.find(b => b.uid == pageId).page.network
          const getStatus = (status) => {
            switch(status) {
              case 1 : return 'planifié'
              case 2 : return 'posté'
              case 3 : return 'erreur'
              case 4 : return 'erreur'
              case 5 : return 'erreur'
              case 6 : return 'brouillon'
            }
          }
          const getTypePost = (pageEmbed) => {
            if(pageEmbed.story) return 'story'
            else if(pageEmbed.document_title) return 'document'
            else if(pageEmbed.poll) return 'sondage'
            else if(pageEmbed.video) return 'video'
            else if(pageEmbed.multipleMedias) return 'multiple_medias'
            else if(pageEmbed.carousel) return 'multiple_images'
            else if(pageEmbed.enclosure) return 'images'
            else return 'standard'
          }
          const getErrorPost = (pageEmbed) => {
            if(pageEmbed.status == 3) return "Erreur introuvable"
            else if([4,5].includes(pageEmbed.status)) return pageEmbed.post_number
            else return ''
          }
          postsReporting = postsReporting.filter(p => p && p.page && p.page[0] && [1,2,3,4,5,6].includes(p.page[0].status)).map(p => {
            return {
              created_at: p.created_at || p.published_at,
              posted_at: p.page[0].posted_date || p.page[0].scheduled_date,
              page: getNamePageById(p.page[0].id),
              network: getNetworkPageById(p.page[0].id),
              status: getStatus(p.page[0].status),
              type_post: getTypePost(p.page[0]),
              // post_link,
              error: getErrorPost(p.page[0])
            }
          })
          console.log('postsReporting', postsReporting)

          const { Parser } = require('json2csv');
          const json2csvParser = new Parser({delimiter: ';'})
          const csv = json2csvParser.parse(postsReporting);
          download(csv)

          function download(data, lastPage, dateStart, dateEnd ){
            const blob=new Blob([data], { type: `text/csv` })
            const url=window.URL.createObjectURL(blob)
            const a=document.createElement('a')
            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', `reporting_posts_agences-migs.csv`)
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
          */
          
          this.percentLoader = 0
          this.showLoader = false
          this.nextComponent = true
          this.eventSource.close();
          this.eventSource = null
          this.$forceUpdate();
          this.arrayPostsFilter()
          if(this.activeSynchronized)
            this.synchronizePosts()
        }

      };
      
    },

    async synchronizePosts() {
      this.activeSynchronized = true

      if(!this.filter.includes('all') && !this.filter.includes('direct'))
        return this.filter.push('direct')

      if(!this.selectedPages.find(p => ['facebook', 'linkedin'].includes(p.network) || (p.network == 'instagram' && !p.isGroup))) return

      this.loadSynchronisation = true
      let since = this.monthly ? moment(moment(this.startDate).startOf('month')).unix()
                               : moment(this.startDate).unix()
      let until = this.monthly ? moment(moment(this.startDate).endOf('month')).unix()
                               : moment(moment(this.startDate).add(6, 'days').hour(23).minute(59).second(59)).unix()
                               
      if(moment().unix() < since) return

      let synchronizedPosts = localStorage.synchronizedPosts ? JSON.parse(localStorage.synchronizedPosts) : null

      for(let page of this.selectedPages) {
        let posts = null

        if(synchronizedPosts) {
          let synchronizedPostsPage = synchronizedPosts.find(p => p.page == page.id)
          if(synchronizedPostsPage 
                && since >= synchronizedPostsPage.since
                && until <= synchronizedPostsPage.until) {
            posts = synchronizedPostsPage.posts.filter(p => since <= moment(p.page[0].posted_date).unix()
                                                                && until >= moment(p.page[0].posted_date).unix())
          }
        }

        if(!posts) { 
          let response = await this.getPostsFromRS(page.id, since, until)
          console.log('synchronizePosts', page, response)
          let bot = this.bots.find(b => b.page.id == page.id)


          posts = response.body.posts.data.filter(p => !this.postsTmp.find(t => t.page && t.page.length && t.page.find(pEmbed => pEmbed.post_number 
                    && (pEmbed.post_number.includes(p.id) 
                          || p.id.includes(pEmbed.post_number) 
                          || (page.network == 'facebook' && [p.attachments.data[0].target.id, p.id] == pEmbed.post_number))))).map(p => { 
            let post
            switch(page.network) {
              case 'instagram' :
                post = {
                  title: p.caption,
                  description: p.caption,
                  created_at: p.created_time,
                  published_at: p.created_time,
                  // "url": "",
                  "enclosure": p.media_url,
                  "page": [
                    {  
                      "isManualPost": true,
                      "id": bot.id,
                      "post_number": p.id,
                      "posted_date": p.created_time,
                      "network": page.network,
                      "status": 2,
                      "video": p.media_type == 'VIDEO' ? p.media_url : null,
                      "enclosure": p.media_type == 'IMAGE' ? p.media_url : null,
                      "carousel": p.media_type == 'CAROUSEL_ALBUM' ? p.medias : null,
                      "link": p.permalink,
                      "comment_count": p.comment_count
                    }
                  ],
                  "_id": `network_post_id-${p.id}`,
                  "id": `network_post_id-${p.id}`,
                  "_bots": [bot],
                  "status": "direct"
                }
                break
              case 'facebook':
                post = {
                  title: p.message,
                  description: p.message,
                  created_at: p.created_time,
                  published_at: p.created_time,
                  "url": p.link ? p.link : null,
                  "enclosure": p.full_picture,
                  "page": [
                    {  
                      "isManualPost": true,
                      "id": bot.id,
                      "post_number": p.id,
                      "posted_date": p.created_time,
                      "network": page.network,
                      "status": 2,
                      "video": p.attachments && p.attachments.data && p.attachments.data.length && p.attachments.data[0].type == 'video_inline' ? p.video : null,
                      "enclosure": p.attachments && p.attachments.data && p.attachments.data.length && p.attachments.data[0].type == 'photo' ? p.attachments.data[0].media.image.src : null,
                      "carousel": p.attachments && p.attachments.data && p.attachments.data.length && p.attachments.data[0].type == 'album' ? p.medias : null,
                      "link": p.permalink_url,
                      "likes": p.likes,
                      "comments": p.comments
                    }
                  ],
                  "_id": `network_post_id-${p.id}`,
                  "id": `network_post_id-${p.id}`,
                  "_bots": [bot],
                  "status": "direct"
                }
                break
              case 'linkedin':
                post = {
                  title: p.message,
                  description: p.message,
                  created_at: p.created_time,
                  published_at: p.created_time,
                  "url": p.link ? p.link : null,
                  "enclosure": p.full_picture,
                  "page": [
                    {  
                      "isManualPost": true,
                      "id": bot.id,
                      "post_number": p.id,
                      "posted_date": p.created_time,
                      "network": page.network,
                      "status": 2,
                      // "video": p.media_type == 'VIDEO' ? p.media_url : null,
                      // "link": p.permalink_url,
                      "likes": p.like_count,
                      "comments": p.comment_count,
                      "carousel": p.carrousel && p.carrousel && p.carrousel.length ? p.carrousel : null,
                    }
                  ],
                  "_id": `network_post_id-${p.id}`,
                  "id": `network_post_id-${p.id}`,
                  "_bots": [bot],
                  "status": "direct"
                } 
                if(p.content && p.content.contentEntities && p.content.contentEntities.length){
                  if(p.content.contentEntities[0].entity.includes("urn:li:article:")) {
                    post.url = p.content.contentEntities[0].entityLocation 
                    post.enclosure = p.content.contentEntities[0].thumbnails && p.content.contentEntities[0].thumbnails.length && p.content.contentEntities[0].thumbnails[0] && p.content.contentEntities[0].thumbnails[0].resolvedUrl
                  }
                  else if(p.content.contentEntities[0].entity.includes("urn:li:digitalmediaAsset:")) {
                    post.enclosure = p.content.contentEntities[0].thumbnails && p.content.contentEntities[0].thumbnails.length && p.content.contentEntities[0].thumbnails[0] && p.content.contentEntities[0].thumbnails[0].resolvedUrl
                    post.page[0].enclosure =  p.content.contentEntities[0].thumbnails && p.content.contentEntities[0].thumbnails.length && p.content.contentEntities[0].thumbnails[0] && p.content.contentEntities[0].thumbnails[0].resolvedUrl
                  }
                }
                if(p.video) {
                  post.page[0].video = p.video
                  post.page[0].enclosure = p.attachment_url
                  if(p.video.downloadUrl) {
                    post.page[0].video = p.video.downloadUrl
                    post.page[0].enclosure = p.video.thumbnail 
                  }
                }
                if(p.document_title && p.document){
                  post.page[0].document_title = p.document_title
                  post.page[0].enclosure = p.document.downloadUrl
                }
                break
            }
  
            return post ? post : p
          })

          // let synchronizedPosts = JSON.parse(localStorage.synchronizedPosts)
          if(!localStorage.synchronizedPosts) {
            synchronizedPosts = []
          }
          if(!synchronizedPosts.find(s => s.page == page.id)) {
            synchronizedPosts.push({
              page: page.id,
              since,
              until,
              posts
            })
          }
          else {
            let ind = synchronizedPosts.findIndex(s => s.page == page.id)
            synchronizedPosts[ind] = {
              page: page.id,
              since: since < synchronizedPosts[ind].since ? since : synchronizedPosts[ind].since,
              until: until > synchronizedPosts[ind].until ? until : synchronizedPosts[ind].until,
              posts: synchronizedPosts[ind].posts.concat(posts)
            }
          }

          localStorage.synchronizedPosts = JSON.stringify(synchronizedPosts)
        }

        console.log('post filter', posts)

        for(let p of posts) {
          this.postsTmp.push(p)
          if(this.weeklyPlanner) {
            let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
            let dayIndex = moment(p.created_at).local().day()
            let hour = moment(p.created_at).local().hours()
            this.weeklyPlanner[days[dayIndex]].slots[hour].push(p)
            // this.$forceUpdate();
          }
          else if(this.monthlyPlanner) {
            let date = moment(p.created_at).local().format('DD/MM/YYYY')
            let dayIndex = this.monthlyPlanner.findIndex(d => d.date == date)
            if(dayIndex >= 0)
              this.monthlyPlanner[dayIndex].posts.push(p)
              // this.$forceUpdate();
          }
        }
      
      }
      this.loadSynchronisation = false
    },

    processInsights(post, index) {
      if(post.page && post.page.length > 0 &&
        (
          post.page[0].status == 2 ||
          (post.page[0].status == 1 && new Date(post.page[0].scheduled_date).getTime() <= new Date().getTime())
        )
      ){
        this.getInsights([post]).then(res => {
          let post = this.posts[index].posts.find(p => p._id == res.body.posts[0]._id)

          this.$set(this.posts[index].posts, this.posts[index].posts.indexOf(post), res.body.posts[0])
          this.queue.unlock()
        })
      }
    },

    processMetaOg(post, index) {
      if(!post.enclosure){
        this.queueMeta.unlock()


        if(post.url) {
          this.getNewsMeta(post.url).then(res => {
            const { success, meta } = res.body

            if (!success || success !== true) {
              this.queueMeta.unlock()
              return
            }

            if(meta && meta.og && meta.og.image){
              let indexPost = this.posts[index].posts.findIndex(p => p.id == post.id)
              post.enclosure = meta.og.image
              this.$set(this.posts[index].posts, indexPost, post)
            }
          })
        }

      }
      else this.queueMeta.unlock()
    },

    setDateStart(date) {
      console.log(this.dateStart, date);
      if (this.dateStart === date) return
      this.dateStart = moment(date).startOf('day').toDate();
      this.arrayPostsFilter(true)
    },

    setDateEnd(date) {
      if (this.dateEnd === date) return
      this.dateEnd = moment(date).endOf('day').toDate();
      this.arrayPostsFilter(true)
    },

    updatePostsToExport(arr){
      let end = moment(moment(this.dateEnd).format('MM-DD-YY'))
      let start = moment(moment(this.dateStart).format('MM-DD-YY'))
      this.postsToExport = arr.filter( item => moment(moment(item['created_at']).format('MM-DD-YY')).isBetween(start, end, null, '[]'))
    },
    
    /**
     * Create Array from pages
     */
    createArray() {
      for (let key in this.linked) {
        let id = this.linked[key].id
        this.posts.push({
          pages: this.linked[key],
          posts: []
        })
      }

      // if(this.activeSection == 'tab'){
        // selectedPages
        if(localStorage.last_selected_pages && !['undefined', '[]', '[null]'].includes(localStorage.last_selected_pages) && JSON.parse(localStorage.last_selected_pages)){
          this.selectedPages = JSON.parse(localStorage.last_selected_pages).map(p => this.linked.find(l => l.id == p.id))
          this.selectedTab = this.linked.findIndex(l => l.id == this.selectedPages[0].id)

        }
        else if(localStorage.last_selected_page && localStorage.last_selected_page != 'undefined' && JSON.parse(localStorage.last_selected_page)){
          this.selectedPages = [JSON.parse(localStorage.last_selected_page)]
          this.selectedTab = this.linked.findIndex(l => l.id == this.selectedPages[0].id)
        }
        else if(this.user && this.user.role && this.user.role.length && this.user.role[0] === 'Viewer') {
          this.selectedPages = this.linked
          this.selectedTab = 0
        }
        else {
          this.selectedPages = this.linked && this.linked.length ? [this.linked[0]] : []
          this.selectedTab = 0
        }
        this.filterPosts()
      // }

      this.groups = this.groups.map(g => {
        return {
          ...g,
          pages: g.pages.filter(page => this.posts.find(p => p.pages.id == page))
        }
      })
      this.updateGroups()

    },

    displayOverlay(clean=false, day=null, hour=null, minute=null) {

      let checkPage = (p) => this.checkLock(p.network) && p.bot_status 

      this.hidePostOverlay = false
      if(clean){
        this.close()
        this.overlayPage = this.linked[this.selectedTab].id
        this.overlayPages = this.selectedPages.filter(p => checkPage(p)).map(p => p.id)
        this.closePostsOverlay = false
      } 

      if(day && hour && minute)
        this.scheduledOverlay = {day, hour, minute}
      else if(day && hour)
        this.scheduledOverlay = {day, hour, minute: 0}
      else 
        this.scheduledOverlay = {
          day: null,
          hour: null,
          minute: null
        }

      // Check the selected page is available, if any
      this.showAdd = true
    },
    
    editDraft(draft, page=null){
      console.log("editDraftoo",draft)
      if(!['Admin', 'Editor', 'Writter'].includes(this.getUserRole)) return

      if (draft.data && draft.data.saveAllFormData) {
        this.$store.commit('postCreator/setDataForDraft', {
          data : draft.data,
          id : draft.id
        });
        this.$router.push('/dash/postCreator/draft');
      }else{
        this.close()
        this.overlayItem = draft
        if (page) {
          this.overlayPage = page.id
          this.overlayPages = [page.id]
        } 
        this.showAdd = true
        this.closePostsOverlay = false
        this.overlayState = 'edit-draft'
        this.scheduledOverlay = {
          day: draft.data.scheduling.date, 
          hour: draft.data.scheduling.time.HH, 
          minute: parseInt(draft.data.scheduling.time.mm)}
      }
     
    },

    showPost(pages, id) {
      this.showAdd = true
      this.popup.validated = true
      this.popup.title = this.$t('dash.posts.confirmation.title')
      this.popup.content = this.$t('dash.posts.confirmation.description')
      let post = this.listPosts.find(function(element) {
        return element._id === id
      })
      this.overlayState = 'show-post'
      this.overlayItem = post
      this.overlayPage = pages
    },

    resetDeleteSot(){
      this.isDeleteSlot = false
      this.slotDate = null
      this.slotBot = null
    },

    changeStartDate(date) {
      this.startDate = date
    },

    exportData(){
      let postsData = this.postsToExport
      let botName = postsData[0]._bots[0] ? postsData[0]._bots[0].name : ( postsData[0]._bots ? postsData[0]._bots.name : "") 
      let statusFilter = this.filterExport !== 'all' ? ('-'+this.filterExport) : ""
      let today = this.formatDateHyphen(moment().format())

      console.log(postsData)
      postsData.forEach(item => {

                  item['created_at'] = moment(item['created_at']).local().format()
                  item['scheduled_date'] = item.status==1 ? moment(item['page'][0]['scheduled_date']).local().format()  : ""
                  item['posted_date'] = item.status==2 ? moment(item['page'][0]['posted_date']).local().format()  : ""
                  item['status'] = item.status==0  
                                  ? this.$t('dash.posts.status.inqueue') 
                                  : ( item.status==1 ? this.$t('dash.posts.status.scheduled') 
                                  : (item.status==3 ? this.$t('dash.posts.status.inprogress') : this.$t('dash.posts.status.posted') ))
      }); 
      console.log(postsData.length)
      let fields = []

      const { Parser } = require('json2csv');
      fields = [
          'status', 
          {label: this.$t('dash.posts.export_created_at'), value:'created_at'},
          {label: this.$t('dash.posts.export_scheduled_date'), value:'scheduled_date'},
          {label: this.$t('dash.posts.export_posted_date'), value:'posted_date'},
          {label: this.$t('dash.posts.export_title'), value:'title'},
          'url',
          {label: this.$t('dash.posts.export_enclosure'), value:'enclosure'},
          'id'
        ]
      try {
        const json2csvParser = new Parser({fields: fields, delimiter: ';', withBOM: true })
        const csv = json2csvParser.parse(postsData);
        download(csv)
        this.popupExport = false
        this.$vs.notify({color:'success',title:'Success',text:'Your file is now downloading'})
      } catch (err) {
        console.error(err);
        this.$vs.notify({color:'danger',title:'Error',text:'Failed download error'})
      } 

      function download(data){
        const blob=new Blob([data], { type: `text/csv` })
        const url=window.URL.createObjectURL(blob)
        const a=document.createElement('a')
        a.setAttribute('hidden', '')
        a.setAttribute('href', url)
        a.setAttribute('download', `planning-${botName}${statusFilter}-${today}.csv`)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)   

      }

    },

    formatDateHyphen(date) {
      if (this.$i18n.locale === 'en') {
        return  moment(date).format('MM-DD-YY').toString()
      } else {
        return moment(date).locale(this.$i18n.locale || navigator.language).format('DD-MM-YY').toString()
      }
    },
   
    onChange() {
      this.fileInput = [...this.$refs.file.files];
      console.log('this.$refs.file',this.$refs.file)
    },
    remove(i) {
      this.fileInput.splice(i, 1);
      this.fileInputParesed =  []
      this.$refs.file.files = null
    },
    
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
    },

    isCSV(){
      if(this.fileInput && this.fileInput[0] && this.fileInput[0].name ){
        let filename = this.fileInput[0].name 
        return (filename.substring(filename.lastIndexOf('.')+1, filename.length) || filename) === 'csv' ? true : false
      }
    },
    
    csv2JSON(csv){
      const lines = csv.split(/\r?\n/) // Split the input string by \n to get the individual lines.
      let header = lines[0].split(';') // Split the first line by , to get the headers.
      header.forEach((element,i) => {
        let el = element.replace(/['"]+/g, '') //remove double quotes from a String
        if (['Creation date','Date de création'].includes(el))
          header[i]= "creationDate" 
        if (["Scheduled date","Date de planification"].includes(el) ) 
          header[i]= "scheduledDate"
        if (["Title","Titre"].includes(el))
          header[i]= "title"
        if (["Image link","Lien de limage" ].includes(el))
          header[i] = "imageUrl"
      });
      
      let output = lines.slice(1).map(line => {
        if( this.notEmpty(line.split(';')[0]) ){ // check if ligne is not empty
          const fields = line.split(';') // Split the following lines by ; to get the fields.
          return Object.fromEntries(header.map((h, i) => [h, fields[i]])) // Join the headers and fields by index (map the headers into an array of header name and field name), and create an object from the result.
        }
      }).filter(Boolean)

      return JSON.parse(JSON.stringify(output).replace(/\\"/g, ''))
    
      
    },

    loadCSV(e) {
      let th = this
      if (this.isCSV()){
        this.$vs.notify({color:'success',title:'Upload Success',text:'Upload Success'})
        if (window.FileReader) {
          var reader = new FileReader();
          reader.readAsText(e.target.files[0], 'ISO-8859-1');
          // Handle errors load
          reader.onload = function(event) {
            let csv = event.target.result;
            th.fileInputParesed = th.csv2JSON(csv)
          };
          reader.onerror = function(evt) {
            if(evt.target.error.name == "NotReadableError") {
              alert("Canno't read file !");
            }
          };
        } else {
          alert('FileReader are not supported in this browser.');
        }

      }
      else {
        this.$vs.notify({color:'danger',title:'Error',text:"The file-type doesn't belong to csv"})
      }
    },

    multipleSchedules(){
      let selectedPage =  this.posts[this.selectedTab]
      let bot = this.bots.find(bot => bot.page.id === selectedPage.pages.id)
      let scheduledArray = ['Planifié', 'Scheduled','1',1]
      let queueArray = ['En attente', 'In queue','0',0]

      this.fileInputParesed.forEach((post,index) => {
        let body = {
          bot: bot.id,
          service: bot.service,
          data: {
              title: "",
              url: "",   
              scheduled_date: "",
              enclosure: null,
              video: null,
              story_instagram: null
            },
        }
          console.log(post.status)
          try{
            if( post.status && scheduledArray.includes(post.status) ){ 
                console.log('scheduled post', post)
                
                if (this.notEmpty(post.title) && this.notEmpty(post.scheduledDate)){  

                  if(selectedPage.pages.network === "twitter" && post.title.length>280){
                        console.log('tweet > 280 characters')
                  }else if(selectedPage.pages.network === "instagram" 
                          && !this.notEmpty(post.imageUrl)){
                            console.log('instagram post must include image')
                  }else{
                                              
                        let sameId =  this.postsTmp.find(p=> JSON.stringify(p.id) === JSON.stringify(post.id) && p.status != 2)
                        console.log('sameId',sameId)

                        body.data.title = post.title
                        body.data.scheduled_date = post.scheduledDate
                        if(this.notEmpty(post.url)) body.data.url = post.url 
                        if(this.notEmpty(post.imageUrl)) body.data.enclosure = post.imageUrl 
                        
                        if(this.notEmpty(post.id)){ // id not empty
                          
                          console.log('id not empty')
                          if(sameId){ // id exist in the list
                            console.log('post exist with this id')
                            if (sameId.id)     body.id = sameId.id
                            if (sameId.flux)   body.data.flux = sameId.flux.id

                            if(scheduledArray.includes(sameId.status)){ // scheduled status

                              if(sameId.page[0] && sameId.page[0].post_number ) 
                                  body.postId = sameId.page[0].post_number 

                              body.last = true
                              this.update(body)

                            }else if (queueArray.includes(sameId.status)){  // queue status
                              body.data.original = sameId.id  // to delete original post
                              body.scheduled=true,
                              this.add(body)
                            }
                          }else{
                            console.log('post not exist with this id')
                          }


                        }else{
                          console.log('empty id')
                          let sameUrl =  this.postsTmp.find(p=> p.url && (p.url === body.data.url))
                          console.log('sameUrl', sameUrl) 
                          if(sameUrl){
                            console.log('News already posted !')        
                            // this.$vs.notify({color:'danger',title:'Error',text:`Post N°0${index+1} :${this.$t('dash.posts.error.already_posted')} `})
                            this.notify({
                              title: 'Error',
                              text: `Post N°0${index+1} :${this.$t('dash.posts.error.already_posted')} `,
                              color: 'danger',
                              id: 'norepeat'
                            }, {
                              component: "Posts",
                              action: "multipleSchedules"
                            })
                          }else{
                            body.scheduled=true
                            this.add(body)     
                          }
                        }

                      }
                }else{
                  console.log('empty title or scheduled date')
                }

            
            }
          }catch (err) {
            return this.handleError(err)
          }
          
      })
      
      this.popupImport = false
    },

    notEmpty(element){
        return element && !(element.length === 0 || /^\s*$/.test(element)) ? true : false
    },

    updateRecap(){
      const elements = document.getElementsByClassName("vs-tooltip");
      while (elements.length > 0) elements[0].remove();
      this.keyRecap++
    },

    async fetchDrafts(page){
      // await this.getDrafts(this.selectedPages.map(p => p.id)).then(res => {
      //   this.drafts = res
      //   if(this.activeSection == 'calendar') {
      //     if(this.posts[this.indexPage].monthlyCalendar) {
      //       this.posts[this.indexPage].monthlyCalendar.map(day => {
      //         return {
      //           ...day,
      //           posts: day.posts.filter(p => p.status != 'draft')
      //         }
      //       })
      //     }
      //     else {
      //       for(let day in this.posts[this.indexPage].calendar) {
      //         this.posts[this.indexPage].calendar[day].slots = this.posts[this.indexPage].calendar[day].slots.map(slots => slots.filter(p => p.status != 'draft'))
      //       }
      //     }
      //     let endDate = moment(this.startDate).add(6, 'days').hour(23).minute(59).second(59)
      //     let tmpDraftsPages = []
      //     for(let d of this.drafts) {
      //       let page = this.selectedPages.find(p => d.affected_to.includes(p.id) && !tmpDraftsPages.find(t => t.id == d.id && t.page == p.id))
      //       tmpDraftsPages.push({
      //         id: d.id,
      //         page: page.id
      //       })
      //       let scheduling = d.data.editPostValue.find(e => e.page == page.id) && d.data.editPostValue.find(e => e.page == page.id).scheduling
      //                           ? { 
      //                               ...d.data.editPostValue.find(e => e.page == page.id).scheduling,
      //                               show: true
      //                             }
      //                           : d.data.scheduling

      //       let monthlyCalendar = this.posts[this.indexPage].monthlyCalendar
      //       if(monthlyCalendar && scheduling && scheduling.show) {
      //         let dayIndex = monthlyCalendar.findIndex(d => d.date == moment(scheduling.date).hour(scheduling.time.HH).minute(scheduling.time.mm).format('DD/MM/YYYY'))
      //         if(dayIndex >= 0) 
      //           monthlyCalendar[dayIndex].posts.push({
      //             _bots: [{ 
      //               ...this.bots.find(b => b.page.id == page.id),
      //               page: page, 
      //               type: page.network,
      //               id: this.bots.find(b => b.page.id == page.id).uid
      //             }],             
      //             enclosure: d.data.multipleImages && d.data.multipleImages.length ? d.data.multipleImages[0].url : d.data.form.enclosure,
      //             published_at: d.updated_at,
      //             status: 'draft',
      //             title: d.data.editPostValue.find(e => e.page == page.id) && d.data.editPostValue.find(e => e.page == page.id).title
      //                           ? d.data.editPostValue.find(e => e.page == page.id).title
      //                           : d.data.form.title,
      //             url: d.data.form.url,
      //             typePost: d.data.typePost,
      //             page: [{
      //               id: this.bots.find(b => b.page.id == page.id).uid,
      //               isDashboard: true,
      //               isManualPost: true,
      //               network: page.network,
      //               scheduled_date: moment(scheduling.date).hour(scheduling.time.HH).minute(scheduling.time.mm).format(),
      //               status:6,
      //               utm:"",
      //               enclosure: d.data.multipleImages && d.data.multipleImages.length ? d.data.multipleImages[0].url : d.data.form.enclosure,
      //               comments: d.data.comments ? d.data.comments : null,
      //               wait_validation: d.data.wait_validation ? d.data.wait_validation : null,
      //               carousel: d.data.multipleImages || null,
      //               poll: d.data.poll || null
      //             }],
      //             draft: d,
      //             id: d.id,
      //             _id: d.id,
      //             scheduled_date: moment(scheduling.date).hour(scheduling.time.HH).minute(scheduling.time.mm).format(),
      //           })
      //       }
                                
      //       else if(scheduling && scheduling.show
      //             && moment.min(moment(scheduling.date).hour(scheduling.time.HH).minute(scheduling.time.mm), this.startDate) == this.startDate 
      //             && moment.max(moment(scheduling.date).hour(scheduling.time.HH).minute(scheduling.time.mm), endDate) == endDate ){
                  
      //         let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']      
      //         let dayIndex = moment(scheduling.date).day()
      //         let hour = parseInt(scheduling.time.HH)
      //         let calendar = this.posts[this.indexPage].calendar
      //           calendar[days[dayIndex]].slots[hour].push({
      //             _bots: [{ 
      //               ...this.bots.find(b => b.page.id == page.id),
      //               page: page, 
      //               type: page.network,
      //               id: this.bots.find(b => b.page.id == page.id).uid
      //             }],            
      //             enclosure: d.data.multipleImages && d.data.multipleImages.length ? d.data.multipleImages[0].url : d.data.form.enclosure,
      //             published_at: d.updated_at,
      //             status: 'draft',
      //             title: d.data.form.title,
      //             url: d.data.form.url,
      //             typePost: d.data.typePost,
      //             // page: [],
      //             page: [{
      //               id: this.bots.find(b => b.page.id == page.id).uid,
      //               isDashboard: true,
      //               isManualPost: true,
      //               network: page.network,
      //               scheduled_date: moment(scheduling.date).hour(scheduling.time.HH).minute(scheduling.time.mm).format(),
      //               status:6,
      //               utm:"",
      //               enclosure: d.data.multipleImages && d.data.multipleImages.length ? d.data.multipleImages[0].url : d.data.form.enclosure,
      //               comments: d.data.comments ? d.data.comments : null,
      //               wait_validation: d.data.wait_validation ? d.data.wait_validation : null,
      //               carousel: d.data.multipleImages || null,
      //               poll: d.data.poll || null
      //             }],
      //             draft: d,
      //             id: d.id,
      //             _id: d.id,
      //             scheduled_date: moment(scheduling.date).hour(scheduling.time.HH).minute(scheduling.time.mm).format(),
      //           })
      //           this.$set(this.posts[this.selectedTab], 'calendar', calendar)
      //         // }
      //       }
      //     }
      //   }
      // })
    },

    async createSharedPlanner(form) {
      this.popupSharedPlanner = false
      console.log('createSharedPlanner', form)

      const makeid = (length) => {
          let result = '';
          const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          const charactersLength = characters.length;
          let counter = 0;
          while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
          }
          return result;
      }

      let body = {
        firstname: form.firstname,
        lastname: form.lastname,
        email: form.email,
        password: makeid(10),
        admin: false,
        account: `${this.user.account}`,
        pages_access: form.pages,
        role: ['Viewer'],
        locale: this.user.locale
      }
      this.createUser(body).then(res => {
        const { success, user, error } = res.body

        if(!success && !user && error)
          this.notify({
            color:'primary',
            title: this.$t('dash.posts.error.title'),
            text: this.$t(error),
            id: 'norepeat'
          })
        else
          this.getViewerUrl(user.id).then(res => {
            if(res.body && res.body.success && res.body.url) {
              this.urlSharedPlanner = res.body.url
              this.popupUrlSharedPlanner = true
              this.copyUrlSharedPlanner(false) 
            }
          })
      })
    },

    copyUrlSharedPlanner(close=true) {
      const el = document.createElement('textarea');  
      el.value = this.urlSharedPlanner;                                 
      el.setAttribute('readonly', '');                
      el.style.position = 'absolute';                     
      el.style.left = '-9999px';                      
      document.body.appendChild(el);                  
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
      el.select();                                    
      document.execCommand('copy');                   
      document.body.removeChild(el);                  
      if (selected) {                                 
        document.getSelection().removeAllRanges();    
        document.getSelection().addRange(selected);   
      }

      if(close) this.popupUrlSharedPlanner = true

      this.notify({
        color:'primary',
        title: this.$t('dash.posts.success'),
        text: this.$t('dash.pages.copy.url_shared_planner'),
        id: 'repeat'
      })
    },

    updateGroups() {
      if(this.groups) {
        this.groups.forEach(g => {
          if(this.selectedPages.filter(page => g.pages.includes(page.id)).length == g.pages.length){
            if(!this.selectedGroups.includes(g.id) && document.getElementById(`groups-${g.id}`)) {
              this.selectedGroups.push(g.id)
              document.getElementById(`groups-${g.id}`).checked = true
            }
          }
          else {
            if(this.selectedGroups.includes(g.id) && document.getElementById(`groups-${g.id}`)) {
              this.selectedGroups.splice(this.selectedGroups.findIndex(s => s == g.id), 1)
              document.getElementById(`groups-${g.id}`).checked = false
            }
          }
        })
      }
    },

    goToListUsers() {
      window.location = '/#/dash/settings/users'
    },

   

  },
  watch: {

    selectAllPages: function() {
      if(this.selectAllPages)
        this.selectedPages = this.posts.filter(p => !(!this.checkLock(p.pages.network) || (!this.isUserPremiumActive && this.posts[0].pages.id !== p.pages.id && !this.isUserPartner)))
                                  .map(p => p.pages)
      else 
        this.selectedPages = []
    },

    showAdd: function(newVal, oldVal) {
      if(newVal != oldVal && newVal == false){
        let canvas = document.getElementsByTagName('canvas')
        canvas.forEach(c => c.remove())
      }
    },

    selectedPages: function(newVal, oldVal) {
      if(this.selectedPages && this.selectedPages.length == 0) this.filterSelected = false
      if(newVal.filter(val => !oldVal.map(d => d.id).includes(val.id)).length){
        this.updateSelected(0)
        if(this.activeSection == 'calendar') this.reloadDataCalendar()
        else this.retrievePosts(this.selectedTab, this.linked[this.selectedTab].id)
      }
      else {
        localStorage.setItem('last_selected_page', JSON.stringify(this.selectedPages[0]))
        localStorage.setItem('last_selected_pages', JSON.stringify(this.selectedPages))
      }

      if(this.selectedPages.length == this.posts.filter(p => !(!this.checkLock(p.pages.network) || (!this.isUserPremiumActive && this.posts[0].pages.id !== p.pages.id && !this.isUserPartner))).length)
        this.selectAllPages = true
      
      this.updateGroups()
      this.$store.commit('selectPage/updatePagesSelected', {pagesId: Object.values(this.$store.getters['selectPage/selectPageAllPages']).filter(page => newVal.some(p => p.id == page.id)).map(p => p.id)});
    },

    addPostHeader: function(newVal, oldVal) {
      if(newVal){
        console.log('addPostHeader', newVal)
        this.overlayState = 'new'
        this.displayOverlay(true)
        this.$emit('on-close-post-form')
      }
    },

    activeSection: function(newVal, oldVal){
      //close form create post on section change
      this.close()
      // if(oldVal == 'calendar')
      //   this.reloadDataCalendar()
    },

    'user.role': function(role) {
      if(role && role[0] === 'Viewer') {
          this.selectedPages = this.linked
          this.selectedTab = 0
      }
    },

    'refresh.frequency': function(freq) {
      if (this.refresh.intervalObj) {
        clearInterval(this.refresh.intervalObj)
        this.refresh.intervalObj = null
      }
      if (freq) {
        const f = () => {
          if (this.refresh.enabled && document.visibilityState === 'visible') {
            this.filterPosts()
          }
          this.refresh.last = moment()
        }
        this.refresh.intervalObj = setInterval(f, freq * 1000)
        f()
      }
    }
  }


}
</script>
